import { L as Locale } from './index-6afae4e4.js';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var module = {
  exports: {}
};
(function (module, exports) {
  !function (e, t) {
    module.exports = t();
  }(commonjsGlobal, () => (() => {
    var e = {
        936: function (e) {
          e.exports = (() => {
            var e = {
                850: function (e) {
                  e.exports = (() => {
                    var e = {
                        d: (t, a) => {
                          for (var n in a) e.o(a, n) && !e.o(t, n) && Object.defineProperty(t, n, {
                            enumerable: !0,
                            get: a[n]
                          });
                        },
                        o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
                        r: e => {
                          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                          }), Object.defineProperty(e, "__esModule", {
                            value: !0
                          });
                        }
                      },
                      t = {};
                    e.r(t), e.d(t, {
                      detectAdsBlocked: () => a,
                      getCdpSegments: () => A,
                      getCmpData: () => m,
                      getDmpSegments: () => u,
                      getFeedCookie: () => i,
                      getPPID: () => r,
                      getUserCookie: () => o,
                      getUserPersonalisation: () => c,
                      insertScripts: () => v,
                      setPersonalisedTargeting: () => g
                    });
                    const a = () => !!((() => {
                        const e = (() => {
                          const e = document.createElement("div");
                          return e.setAttribute("class", "pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links ad-text adSense adBlock adContent adBanner"), e.setAttribute("style", "width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;"), e;
                        })();
                        window.document.body.append(e);
                        const t = (e => {
                          if (null === e.offsetParent || 0 == e.offsetHeight || 0 == e.offsetLeft || 0 == e.offsetTop || 0 == e.offsetWidth || 0 == e.clientHeight || 0 == e.clientWidth) return !0;
                          if (void 0 !== window.getComputedStyle) {
                            const t = window.getComputedStyle(e);
                            if (t && ("none" == t.getPropertyValue("display") || "hidden" == t.getPropertyValue("visibility"))) return !0;
                          }
                          return !1;
                        })(e);
                        return e.remove(), t;
                      })() || (() => {
                        let e = !1;
                        return document.querySelectorAll("style").forEach(t => {
                          e = !!t.innerText.includes(":root topadblock");
                        }), e;
                      })() || "object" == typeof window.navigator.brave && void 0 === window.googletag._loaded_),
                      n = "cbc_ppid",
                      r = async () => {
                        const e = o(),
                          t = i(n);
                        return "" !== e.id && e !== t && (e => {
                          const t = new Date();
                          t.setTime(t.getTime() + 31536e6);
                          const a = `; expires=${t.toUTCString()}`;
                          window.document.cookie = `${n}=${e}${a}; path=/; domain=.cbc.ca`;
                        })(e.id), "" !== e.id ? await (async e => {
                          if (null !== ((window.crypto.subtle || {}).digest || null)) {
                            const t = new TextEncoder().encode(e),
                              a = await window.crypto.subtle.digest("SHA-256", t);
                            return Array.from(new Uint8Array(a)).map(e => e.toString(16).padStart(2, "0")).join("");
                          }
                          return null;
                        })(e.id) : null;
                      },
                      i = e => {
                        const t = window.document.cookie.split(";"),
                          a = {
                            name: "",
                            id: ""
                          };
                        return t.forEach(t => {
                          const n = t.split("=");
                          if (n[0] && n[0].trim() === e) return a.name = n[0].trim(), a.id = n[1].trim(), a;
                        }), a;
                      },
                      o = () => {
                        const e = ["cbc_plus", n, "cbc_visitor"];
                        for (let t = 0; t < e.length; t++) {
                          const a = i(e[t]);
                          if ("" !== a.id) return a;
                        }
                        return {
                          name: "",
                          id: ""
                        };
                      },
                      s = "personaliz-CbNGLdPX",
                      l = "personaliz-rT2hmC9K",
                      d = {
                        purposes: {
                          "personaliz-CbNGLdPX": {
                            enabled: !0
                          },
                          "personaliz-rT2hmC9K": {
                            enabled: !0
                          }
                        },
                        vendors: {
                          vendor: {
                            id: "",
                            enabled: !0
                          }
                        }
                      },
                      c = () => {
                        const e = {
                          cmpData: {
                            cmpOptIn: !0,
                            contentOptIn: !0,
                            userStatus: d
                          },
                          cdpSegments: [],
                          dmpSegments: []
                        };
                        e.cmpData = m();
                        const t = e.cmpData.cmpOptIn,
                          a = e.cmpData.contentOptIn;
                        return t && a ? (e.cdpSegments = A(), e.dmpSegments = u()) : t || window.googletag && window.googletag.pubadsReady && window.googletag.setConfig({
                          privacyTreatments: {
                            treatments: ["disablePersonalization"]
                          }
                        }), e;
                      },
                      u = () => {
                        let e = [];
                        const t = window.lotame_10205 || {};
                        return t.getAudiences = t.getAudiences || [], "function" == typeof t.getAudiences ? (e = t.getAudiences(), e) : e;
                      },
                      A = () => {
                        let e = [];
                        const t = window.blueConicClient || {};
                        if (t.getSegments = t.getSegments || [], "function" == typeof t.getSegments) {
                          const a = [];
                          return t.getSegments().forEach(e => {
                            a.push(e.id);
                          }), e = a, e;
                        }
                        return e;
                      },
                      m = () => {
                        window.Didomi = window.Didomi || {}, window.Didomi.getCurrentUserStatus = window.Didomi.getCurrentUserStatus || void 0;
                        const e = {
                          cmpOptIn: !0,
                          contentOptIn: !0,
                          userStatus: d
                        };
                        if (void 0 !== window.Didomi.getCurrentUserStatus) {
                          const t = window.Didomi.getCurrentUserStatus();
                          e.userStatus = t;
                          const a = t.purposes,
                            n = a[s].enabled,
                            r = a[l].enabled;
                          e.contentOptIn = r;
                          const i = Object.values(t.vendors);
                          let o = !0;
                          if (n) for (const e of i) {
                            const t = window.Didomi.getVendorById(`c:${e.id}`);
                            if (t.legIntPurposeIds && t.legIntPurposeIds.includes(s) && !e.enabled) {
                              if (!r && !t.legIntPurposeIds.includes(l)) {
                                o = !1;
                                break;
                              }
                              if (r) {
                                o = !1;
                                break;
                              }
                            }
                          }
                          e.cmpOptIn = n && o;
                        }
                        return e;
                      },
                      g = (e, t) => {
                        const {
                            cdpSegments: a,
                            dmpSegments: n
                          } = e,
                          r = i("ios_a_p");
                        if (!new URLSearchParams(t).get("ios_a_p") && "" === r.id) {
                          const e = n.concat(a);
                          e.length > 0 && window.googletag && window.googletag.pubadsReady && window.googletag.pubads().setTargeting("audienceList", e);
                        }
                      },
                      p = [{
                        elementType: "link",
                        relType: "preconnect",
                        scriptName: "googleTagServicesPreconnect",
                        scriptUrl: "https://www.googletagservices.com",
                        loadMode: "crossorigin"
                      }, {
                        elementType: "link",
                        relType: "dns-prefetch",
                        scriptName: "googleTagServicesPrefetch",
                        scriptUrl: "https://www.googletagservices.com",
                        loadMode: "crossorigin"
                      }, {
                        elementType: "link",
                        relType: "preconnect",
                        scriptName: "adservicePreconnect",
                        scriptUrl: "https://adservice.google.ca",
                        loadMode: "crossorigin"
                      }, {
                        elementType: "link",
                        relType: "dns-prefetch",
                        scriptName: "adservicePrefetch",
                        scriptUrl: "https://adservice.google.ca",
                        loadMode: "crossorigin"
                      }, {
                        elementType: "link",
                        relType: "preconnect",
                        scriptName: "pageadPreconnect",
                        scriptUrl: "https://pagead2.googlesyndication.com",
                        loadMode: "crossorigin"
                      }, {
                        elementType: "link",
                        relType: "dns-prefetch",
                        scriptName: "pageadPrefetch",
                        scriptUrl: "https://pagead2.googlesyndication.com",
                        loadMode: "crossorigin"
                      }, {
                        elementType: "link",
                        relType: "preconnect",
                        scriptName: "securepubadsPreconnect",
                        scriptUrl: "https://securepubads.g.doubleclick.net",
                        loadMode: "crossorigin"
                      }, {
                        elementType: "link",
                        relType: "dns-prefetch",
                        scriptName: "securepubadsPrefetch",
                        scriptUrl: "https://securepubads.g.doubleclick.net",
                        loadMode: "crossorigin"
                      }, {
                        elementType: "script",
                        scriptName: "gpt",
                        scriptUrl: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
                        loadMode: "async"
                      }, {
                        elementType: "script",
                        scriptName: "adLightning",
                        scriptUrl: "https://tagan.adlightning.com/cbc/op.js",
                        loadMode: "async"
                      }, {
                        elementType: "script",
                        scriptName: "pbjs",
                        scriptUrl: "https://www.cbc.ca/g/stats/js/cbc-prebid.js",
                        loadMode: "async"
                      }, {
                        elementType: "script",
                        scriptName: "admiral",
                        scriptUrl: "https://www.cbc.ca/g/stats/js/admiral-script.js",
                        loadMode: "defer"
                      }, {
                        elementType: "script",
                        scriptName: "contxtful",
                        scriptUrl: "//api.receptivity.io/v1/publisher/1Pw320kTdUM9nIw5Vsh5VqQtx/connector/p.js?callback=CONTXTFUL_CALLBACK",
                        loadMode: "async"
                      }],
                      v = function () {
                        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p;
                        "undefined" != typeof window && e.forEach(e => {
                          const t = e.elementType.charAt(0).toUpperCase() + e.elementType.slice(1);
                          if (window.document.querySelector(`#${e.scriptName}` + t)) return;
                          const a = window.document.querySelector("head"),
                            n = window.document.createElement(`${e.elementType}`);
                          "script" === e.elementType ? n.setAttribute("src", `${e.scriptUrl}`) : "link" === e.elementType && (n.setAttribute("rel", `${e.relType}`), n.setAttribute("href", `${e.scriptUrl}`)), n.setAttribute(`${e.loadMode}`, ""), n.setAttribute("id", `${e.scriptName}` + t), null !== a && a.append(n);
                        });
                      };
                    return t;
                  })();
                }
              },
              t = {};
            function a(n) {
              var r = t[n];
              if (void 0 !== r) return r.exports;
              var i = t[n] = {
                exports: {}
              };
              return e[n].call(i.exports, i, i.exports, a), i.exports;
            }
            a.d = (e, t) => {
              for (var n in t) a.o(t, n) && !a.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
              });
            }, a.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), a.r = e => {
              "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
              }), Object.defineProperty(e, "__esModule", {
                value: !0
              });
            };
            var n = {};
            return (() => {
              a.r(n), a.d(n, {
                getAdUrl: () => u,
                getDaiParams: () => A
              });
              var e = a(850);
              const t = "undefined" != typeof window ? document.location.origin + document.location.pathname : "",
                r = "web-app",
                i = "phoenix",
                o = "auto",
                s = "undefined" != typeof window ? "" === document.referrer ? "direct" : "indirect" : "",
                l = [{
                  elementType: "script",
                  scriptName: "casalePrebidHelper",
                  scriptUrl: "https://js-sec.casalemedia.com/ixpb/ix-prebid-helper.js",
                  loadMode: "async"
                }],
                d = t => {
                  const a = t ? (0, e.getDmpSegments)() : [],
                    n = t ? (0, e.getCdpSegments)() : [];
                  return a.concat(n);
                },
                c = e => {
                  var t, a;
                  window.CBC || (window.CBC = {
                    Listen: {
                      currentMediaRequest: {
                        type: ""
                      }
                    }
                  });
                  let n = void 0 !== (null === (t = window.CBC.Listen) || void 0 === t ? void 0 : t.currentMediaRequest.type) && "" !== (null === (a = window.CBC.Listen) || void 0 === a ? void 0 : a.currentMediaRequest.type) ? "listen" : "feed";
                  return n = e.includes("/olympics/") ? "olympics" : n, n;
                },
                u = async a => {
                  const n = await (0, e.getPPID)();
                  let u = "",
                    A = "",
                    m = "";
                  const g = encodeURI(t),
                    p = (0, e.getCmpData)(),
                    {
                      cmpOptIn: v
                    } = p,
                    E = v ? "0" : "1",
                    T = c(a.metadata.adOrder),
                    y = d(v).join();
                  (0, e.insertScripts)(l);
                  try {
                    (() => {
                      const e = {
                        bidders: ["ix"]
                      };
                      window.ixPrebidHelper = window.ixPrebidHelper || {
                        cmd: []
                      }, window.ixPrebidHelper.cmd.push(function () {
                        window.ixPrebidHelper.sendUserSync(e);
                      });
                    })();
                  } catch (e) {
                    console.log("Failed IX user sync");
                  }
                  return a && a.metadata && (u = "https://instream.casalemedia.com/playlist?ix_s=198408&ix_ca=%7B%22protocols%22%3A%5B2%2C3%2C5%2C6%5D%2C%22mimes%22%3A%5B%22video%2Fmp4%22%5D%2C%22apiList%22%3A%5B2%5D%2C%22size%22%3A%22320x240%22%2C%22maxAdDuration%22%3A30%2C%22timeout%22%3A1000%2C%22brandExclusion%22%3A1%7D&ix_vt=https%3A%2F%2Fpubads.g.doubleclick.net%2Fgampad%2Fads&sz=320x240&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&correlator=[timestamp]&ad_rule=1&cmsid=2673647&iu=5876/", m += "plat=" + i + "&ix_u=" + t + "&bu=" + T + "&device=" + r + "&source=" + s + "&audienceList=" + y, a.metadata.adCategoryExclusion && "" !== a.metadata.adCategoryExclusion && (m += "&excl_cat=" + a.metadata.adCategoryExclusion), document.referrer.split("/").indexOf("amp") > -1 && (m += "&env=amp"), u += a.metadata.adOrder + "&ppid=" + n + "&description_url=" + g + "&url=" + g + "&vid=" + a.metadata.id + "&vpi=0&vpmute=0&vpa=" + o + "&plcmt=1&pp=" + r + "&ppt=" + E + "&cust_params="), A = u + encodeURIComponent(m), A;
                },
                A = async a => {
                  const n = await (0, e.getPPID)(),
                    l = "string" == typeof n ? n : "",
                    u = c(a),
                    A = (0, e.getCmpData)(),
                    {
                      cmpOptIn: m
                    } = A,
                    g = m ? "0" : "1",
                    p = d(m).join();
                  return {
                    cust_params: "plat=" + i + "&bu=" + u + "&device=" + r + "&pp=" + r + "&url=" + t + "&source=" + s + "&audienceList=" + p,
                    ppid: l,
                    descriptionUrl: t,
                    vpa: o,
                    vpmute: "0",
                    npa: g
                  };
                };
            })(), n;
          })();
        },
        241: (e, t) => {
          (() => {
            var e,
              a = {
                d: (e, t) => {
                  for (var n in t) a.o(t, n) && !a.o(e, n) && Object.defineProperty(e, n, {
                    enumerable: !0,
                    get: t[n]
                  });
                },
                o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
                r: e => {
                  "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                    value: "Module"
                  }), Object.defineProperty(e, "__esModule", {
                    value: !0
                  });
                }
              },
              n = {};
            a.r(n), a.d(n, {
              GQL_CONTENTITEM_FRAGMENT_FOR_MEDIA: () => i,
              default: () => c,
              fetchFromGraphQL: () => o,
              fetchMediaData: () => s,
              fetchRecommendedItems: () => l,
              getVersion: () => d,
              transformMediaItemToMediaData: () => r
            }), function (e) {
              e.DEV = "dev", e.QA = "qa", e.PROD = "prod", e.STG = "stg";
            }(e || (e = {}));
            const r = e => {
                var t, a, n, r, i, o, s, l, d, c, u;
                if (!(null == e ? void 0 : e.media)) return null;
                const A = {};
                return A.sourceId = e.sourceId, A.mediaId = e.mediaId, A.mediaNetId = null !== (a = null === (t = e.media.id) || void 0 === t ? void 0 : t.toString()) && void 0 !== a ? a : null, A.callSign = e.media.callSign, A.source = e.source, A.format = e.type, A.assets = e.media.assets || null, A.adOrder = e.media.adOrder, A.adCategoryExclusion = e.media.adCategoryExclusion, A.isLive = "Live" === e.media.streamType, A.contentArea = e.media.contentArea, A.contentTier = null !== (r = null === (n = e.media.contentTierId) || void 0 === n ? void 0 : n.toString()) && void 0 !== r ? r : null, A.tags = e.tags || [], A.concepts = e.concepts || [], A.duration = e.media.duration, A.showName = null !== (o = null === (i = e.showData) || void 0 === i ? void 0 : i.name) && void 0 !== o ? o : e.showName, A.title = e.title, A.thumbnail = (e => {
                  var t, a;
                  let n = null == e ? void 0 : e.url;
                  const r = null === (a = null === (t = null == e ? void 0 : e.aspects) || void 0 === t ? void 0 : t.ratio16x9) || void 0 === a ? void 0 : a.url;
                  return r && (n = `${r}Resize%3D1180`), n;
                })(e.image), A.genre = e.media.genre, A.type = e.media.clipType, A.brandedSponsorName = e.media.brandedSponsorName, A.season = null !== (l = null === (s = e.media.season) || void 0 === s ? void 0 : s.toString()) && void 0 !== l ? l : null, A.episode = null !== (c = null === (d = e.media.episode) || void 0 === d ? void 0 : d.toString()) && void 0 !== c ? c : null, A.region = e.media.region, A.pubDate = parseInt(e.publishedAt), A.sport = null === (u = e.media.sports) || void 0 === u ? void 0 : u.name, A.hasCaptions = e.media.hasCaptions, A.aspectRatio = e.media.aspectRatio, A.shareUrl = `https://www.cbc.ca/player/play/${e.type}/${e.sourceId}`, e.media.chapters && (A.chapters = e.media.chapters), e.media.textTracks && (A.textTracks = e.media.textTracks.map(e => ({
                  label: e.label,
                  srclang: e.language,
                  src: e.src,
                  kind: e.kind
                }))), A;
              },
              i = "\n    sourceId\n    mediaId\n    source\n    title\n    image {\n        url\n        aspects {\n            ratio16x9 {\n                url\n            }\n        }\n    }\n    publishedAt\n    type\n    showData {\n        name\n    }\n    showName\n    tags {\n        type\n        name\n    }\n    concepts {\n        type\n        path\n    }\n    media {\n        id\n        callSign\n        assets {\n            key\n            type\n            options {\n                token\n            }\n        }\n        adOrder\n        adCategoryExclusion\n        streamType\n        contentArea\n        contentTierId\n        duration\n        genre\n        clipType\n        brandedSponsorName\n        season\n        episode\n        region\n        sports {\n            name\n        }\n        hasCaptions\n        aspectRatio\n        textTracks {\n            kind\n            label\n            src\n            language\n        }\n        chapters {\n            name\n            startTime\n        }\n    }\n",
              o = async (t, a) => {
                const n = (t => {
                    let a = ".";
                    return t !== e.DEV && t !== e.QA || (a = `.${t}.nm.`), `https://www${a}cbc.ca/${t === e.STG ? "gql-stg" : "graphql"}`;
                  })(a),
                  r = {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Cache-By-Country": "true"
                    },
                    body: JSON.stringify(t)
                  },
                  i = await fetch(n, r);
                return await i.json();
              },
              s = async (e, t, a) => {
                var n;
                if (!e) return null;
                let s = null;
                const l = ((e, t) => ({
                  query: `{ contentItem(${e.toString().includes(".") ? `sourceId: "${e}"` : `mediaId: ${e}`}${t ? `, token: "${t}", workflowState: ALL` : ""}) {\n            ${i}\n        }}`
                }))(e, a);
                try {
                  const e = null === (n = (await o(l, t)).data) || void 0 === n ? void 0 : n.contentItem;
                  if (!e) throw new Error("No GQL media item in GraphQL response");
                  s = r(e);
                } catch (e) {
                  return console.error(e), s;
                }
                return s;
              },
              l = async (e, t, a, n, s) => {
                var l, d, c, u;
                if (!e) throw new Error("Missing mandatory argument 'algorithmId'.");
                const A = Number.isInteger(a) ? a : 2,
                  m = null == n || n,
                  g = {
                    query: ""
                  };
                if (t) g.query = `{\n            personalizedItems(algorithmId: "${e}", userId: "${t}", allowPersonalized: ${m}, first: ${A}) {\n                nodes {\n                    ${i}\n                }\n                algorithmId\n            }\n        }`;else {
                  const t = "rec4you-short-form-news-video" === e ? "short-form-news-video" : "short-form-video";
                  g.query = `{\n            mlDrivenItems(algorithm: "trending", type: "video", pageSize: ${A}, args: { trendingType: "${t}", allowPersonalized: ${n}} }) {\n                items {\n                    ${i}\n                }\n            }\n        }`;
                }
                let p = [];
                try {
                  const e = await o(g, s),
                    a = t ? null === (d = null === (l = null == e ? void 0 : e.data) || void 0 === l ? void 0 : l.personalizedItems) || void 0 === d ? void 0 : d.nodes : null === (u = null === (c = null == e ? void 0 : e.data) || void 0 === c ? void 0 : c.mlDrivenItems) || void 0 === u ? void 0 : u.items;
                  (null == a ? void 0 : a.length) && (p = a.filter(e => {
                    var t, a;
                    return null === (a = null === (t = null == e ? void 0 : e.media) || void 0 === t ? void 0 : t.assets) || void 0 === a ? void 0 : a.length;
                  }).map(e => r(e)));
                } catch (e) {
                  console.error(e);
                }
                return p;
              },
              d = () => "1.8.1",
              c = {
                fetchMediaData: s,
                fetchRecommendedItems: l,
                fetchFromGraphQL: o,
                getVersion: d,
                transformMediaItemToMediaData: r,
                GQL_CONTENTITEM_FRAGMENT_FOR_MEDIA: i
              };
            t.W9 = n.fetchRecommendedItems;
          })();
        }
      },
      t = {};
    function a(n) {
      var r = t[n];
      if (void 0 !== r) return r.exports;
      var i = t[n] = {
        exports: {}
      };
      return e[n].call(i.exports, i, i.exports, a), i.exports;
    }
    a.d = (e, t) => {
      for (var n in t) a.o(t, n) && !a.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }, a.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), a.r = e => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var n = {};
    return (() => {
      a.d(n, {
        default: () => Re
      });
      var e,
        t = {};
      a.r(t), a.d(t, {
        Vu: () => p,
        ll: () => u,
        R1: () => m,
        dm: () => g,
        XQ: () => A
      }), function (e) {
        e[e.OK = 0] = "OK", e[e.ERROR = 1] = "ERROR";
      }(e || (e = {}));
      const r = (e, t) => i(e, t, !0),
        i = async (t, a, n) => {
          try {
            const r = await fetch(t, a);
            if (!r.ok) {
              const e = new Error();
              throw e.name = "FetchError", e.message = "Requesting " + t + "failed with " + r.status + ": " + r.statusText, e;
            }
            const i = n ? await r.json() : await r.text();
            return {
              status: e.OK,
              response: i
            };
          } catch (t) {
            return {
              status: e.ERROR,
              response: t
            };
          }
        },
        o = ["qa", "dev"],
        s = (() => {
          let t;
          return () => (t || (t = (() => {
            let t = !1,
              a = !1;
            return {
              seed: async n => {
                n ? a || (console.warn(`[Phoenix Core] Running in alternate environment mode: ${n}`), a = !0, t = await (async t => {
                  var a, n;
                  if (!o.includes(t)) return {};
                  const i = await r("https://www.cbc.ca/aggregate_api/v1/key-values?key=phoenix.config");
                  if (i.status === e.ERROR) {
                    const e = i.response;
                    return console.warn(`[Phoenix] Attempting to fetch settings for env: ${t} failed:`, e.message), {};
                  }
                  const s = i.response;
                  return (null === (a = s.value) || void 0 === a ? void 0 : a.env) ? null === (n = s.value) || void 0 === n ? void 0 : n.env[t] : {};
                })(n)) : t = {};
              },
              get: e => {
                if ("boolean" != typeof t && 0 !== Object.keys(t).length) {
                  const a = t[e] || !1;
                  return console.warn(`[Phoenix Core] Environment setting using ${a} for ${e}`), a;
                }
                return !1;
              }
            };
          })()), t);
        })(),
        l = "CBC",
        d = (() => {
          let e;
          return t => (e || (e = (e => {
            const t = () => {
                var e;
                return "undefined" != typeof process && !!(null === (e = null === process || void 0 === process ? void 0 : process.env) || void 0 === e ? void 0 : e.PHOENIX_JEST_TEST);
              },
              a = e => {
                var t;
                return `[Phoenix ${null !== (t = e.caller) && void 0 !== t ? t : "Core"}] ${e.name} -> ${e.message}`;
              };
            let n = e || !1;
            return {
              debug: e => {
                t() || (window.wppPhoenixCoreDebug || n) && console.log(a(e));
              },
              error: e => {
                if (t()) return;
                const r = (e => !1 === e.critical)(e);
                (!r || window.wppPhoenixCoreDebug || n) && (r ? console.warn(a(e)) : console.error(a(e)));
              },
              setVerbose: e => {
                n = e;
              }
            };
          })(t)), void 0 !== t && e.setVerbose(t), e);
        })(),
        c = new Map([["flv", "video/x-flv"], ["mp4", "video/mp4"], ["m3u8", "application/x-mpegURL"], ["ts", "video/MP2T"], ["3gp", "video/3gpp"], ["mov", "video/quicktime"], ["avi", "video/x-msvideo"], ["wmv", "video/x-ms-wmv"], ["webm", "video/webm"], ["mp3", "audio/mpeg"], ["wav", "audio/vnd.wav"], ["ogg", "audio/ogg"], ["mid", "audio/mid"], ["aif", "audio/x-aiff"]]),
        u = {
          CRITICAL_ERROR: "CRITICAL_ERROR",
          BUFFER_UPDATED: "BUFFER_UPDATED",
          LIVE_SYNC_POSITION_CHANGE: "LIVE_SYNC_POSITION_CHANGE",
          MEDIA_ASPECT_RATIO_AVAILABLE: "MEDIA_ASPECT_RATIO_AVAILABLE",
          STATUS_CHANGE: "STATUS_CHANGE",
          ASSET_LOADED: "ASSET_LOADED",
          PLAYBACK_INITIALPLAY: "PLAYBACK_INITIALPLAY",
          PLAYBACK_TIMEUPDATED: "PLAYBACK_TIMEUPDATED",
          PLAYBACK_THROTTLED_TIMEUPDATED: "PLAYBACK_THROTTLED_TIMEUPDATED",
          PLAYBACK_PLAYBACKSPEEDCHANGE: "PLAYBACK_PLAYBACKSPEEDCHANGE",
          PLAYBACK_SEEKING: "PLAYBACK_SEEKING",
          PLAYBACK_SEEKED: "PLAYBACK_SEEKED",
          PLAYBACK_VOLUMECHANGE: "PLAYBACK_VOLUMECHANGE",
          PLAYBACK_MUTEDCHANGE: "PLAYBACK_MUTEDCHANGE",
          AD_ERRORED: "AD_ERRORED",
          AD_LOADED: "AD_LOADED",
          AD_STARTED: "AD_STARTED",
          AD_COMPLETED: "AD_COMPLETED",
          AD_BREAK_STARTED: "AD_BREAK_STARTED",
          AD_BREAK_COMPLETED: "AD_BREAK_COMPLETED",
          AD_REMAINING_TIME_UPDATED: "AD_REMAINING_TIME_UPDATED",
          AD_FIRST_QUARTILE: "AD_FIRST_QUARTILE",
          AD_MIDPOINT: "AD_MIDPOINT",
          AD_THIRD_QUARTILE: "AD_THIRD_QUARTILE",
          AD_SKIPPED: "AD_SKIPPED",
          TEXTTRACK_AVAILABILITY_CHANGE: "TEXTTRACK_AVAILABILITY_CHANGE",
          TEXTTRACK_ENABLED: "TEXTTRACK_ENABLED",
          TEXTTRACK_DISABLED: "TEXTTRACK_DISABLED",
          AUDIOTRACK_AVAILABILITY_CHANGE: "AUDIOTRACK_AVAILABILITY_CHANGE",
          HLSJS_PARSE_FRAG_METADATA: "HLSJS_PARSE_FRAG_METADATA",
          CHAPTER_START: "CHAPTER_START",
          CHAPTER_COMPLETE: "CHAPTER_COMPLETE",
          UPCOMING_LIVE_UPDATE: "UPCOMING_LIVE_UPDATE",
          RECOMMENDATIONS_AVAILABLE: "RECOMMENDATIONS_AVAILABLE"
        },
        A = {
          READY: "READY",
          LOADING: "LOADING",
          ERROR: "ERROR",
          PLAYING: "PLAYING",
          ADVERTISING: "ADVERTISING",
          ADVERTISING_PAUSED: "ADVERTISING_PAUSED",
          PAUSED: "PAUSED",
          ENDED: "ENDED"
        },
        m = {
          CLIENTSIDE: "CLIENTSIDE",
          DYNAMIC: "DYNAMIC"
        },
        g = "[data-name='phoenix-playback-element']",
        p = "3.23.1",
        {
          ll: v,
          XQ: E,
          R1: T,
          Vu: y
        } = t;
      var D;
      !function (e) {
        e.subtitles = "subtitles", e.captions = "captions", e.descriptions = "descriptions", e.chapters = "chapters", e.metadata = "metadata";
      }(D || (D = {}));
      const h = new Map([["PLAYER_INJECTION_ERROR", {
          name: "PLAYER_INJECTION_ERROR",
          message: "The container selector supplied is not accessible",
          critical: !0
        }], ["HLS_JS_NOT_SUPPORTED", {
          name: "HLS_JS_NOT_SUPPORTED",
          message: "HlsJS library is not supported",
          critical: !0
        }], ["HLS_JS_LOAD_FAILED", {
          name: "HLS_JS_LOAD_FAILED",
          message: "Failed to load HLSJS library",
          critical: !0
        }], ["HLS_JS_NETWORK_ERROR", {
          name: "HLS_JS_NETWORK_ERROR",
          message: "A network timeout has prevented us from playing this media",
          critical: !0
        }], ["HLS_JS_MEDIA_ERROR", {
          name: "HLS_JS_MEDIA_ERROR",
          message: "We are unable to continute playing this media",
          critical: !0
        }], ["HLS_JS_DEFAULT_ERROR", {
          name: "HLS_JS_DEFAULT_ERROR",
          message: "Technical problems prevent us from playing this media",
          critical: !1
        }], ["TIMEOUT_ERROR", {
          name: "TIMEOUT_ERROR",
          message: "A media timeout has prevented us from playing this media",
          critical: !0
        }], ["NATIVE_MEDIA_ERROR", {
          name: "NATIVE_MEDIA_ERROR",
          message: "Unable to load asset natively: ",
          critical: !0
        }], ["NO_COMPATIBLE_SOURCES", {
          name: "NO_COMPATIBLE_SOURCES",
          message: "None of the given sources can be played",
          critical: !0
        }], ["NO_MEDIA_TO_PLAY", {
          name: "NO_MEDIA_TO_PLAY",
          message: "Can not play, media was not supplied",
          critical: !0
        }], ["AUTOPLAY_UNSUPPORTED", {
          name: "AUTOPLAY_UNSUPPORTED",
          message: "Can not autoplay the media",
          critical: !1
        }], ["PLAYER_CONFIG_ERROR", {
          name: "PLAYER_CONFIG_ERROR",
          message: "Player config requires valid container node",
          critical: !0
        }], ["PLAYER_MEDIA_ERROR_KEY", {
          name: "PLAYER_MEDIA_ERROR_KEY",
          message: "Player media requires valid key",
          critical: !0
        }], ["PLAYER_MEDIA_ERROR_LOADER", {
          name: "PLAYER_MEDIA_ERROR_LOADER",
          message: "Player media requires loader to be a function",
          critical: !0
        }], ["PLAYER_MEDIA_ERROR_FORMAT", {
          name: "PLAYER_MEDIA_ERROR_FORMAT",
          message: "Player media requires a valid format",
          critical: !0
        }], ["PLAYER_MEDIA_ERROR_ASSETPARSERS", {
          name: "PLAYER_MEDIA_ERROR_ASSETPARSERS",
          message: "Player media 'asset parsers' are required",
          critical: !0
        }]]),
        I = "DAIAdsManager",
        R = async (e, t, a) => {
          if (null == t ? void 0 : t()) return !0;
          let n;
          try {
            await f(e, a), n = !0;
          } catch {
            n = !1;
          }
          return n;
        },
        f = (e, t) => {
          var a;
          let n,
            r = !1;
          const i = window.document.querySelector(`script[src='${e}']`);
          i ? (n = i, r = !0) : (n = window.document.createElement("script"), n.setAttribute("type", null !== (a = null == t ? void 0 : t.type) && void 0 !== a ? a : "text/javascript"), n.setAttribute("src", e));
          const o = new Promise((e, t) => {
            const a = () => {
              e();
            };
            n.addEventListener("load", a), n.addEventListener("error", () => {
              n.removeEventListener("load", a), window.document.getElementsByTagName("head")[0].removeChild(n), t();
            });
          });
          return r || window.document.getElementsByTagName("head")[0].appendChild(n), o;
        },
        S = new Map([["hls", "application/x-mpegURL"], ["dash", "application/dash+xml"]]);
      var _ = a(936);
      const b = async (e, t, a, n) => {
          const r = `MacAug ${n}() call took too long!`;
          return Promise.race([e(t), new Promise((e, t) => {
            setTimeout(() => t(r), a);
          })]);
        },
        L = () => {
          var e, t, a, n;
          return "function" == typeof (null === (n = null === (a = null === (t = null === (e = window.google) || void 0 === e ? void 0 : e.ima) || void 0 === t ? void 0 : t.dai) || void 0 === a ? void 0 : a.api) || void 0 === n ? void 0 : n.StreamManager);
        },
        P = "DAILoader",
        w = new Map([["simple", async e => ({
          asset: await (async e => ({
            uri: e,
            mimeType: C(e)
          }))(e.key)
        })], ["platform-dai", async (e, t) => {
          let a,
            n,
            r = null;
          const i = d(),
            o = await (async (e, t) => {
              var o, s, c, u;
              if (!t) return null;
              try {
                const A = e => {
                  const t = [m.StreamEvent.Type.LOADED, m.StreamEvent.Type.ERROR],
                    n = r => {
                      var o;
                      const s = m.StreamEvent.Type;
                      let d = "";
                      switch (r.type) {
                        case s.LOADED:
                          a.removeEventListener(t, n), i.debug({
                            caller: l,
                            name: P,
                            message: "Successfully loaded DAI asset"
                          }), e((e => {
                            var t, a;
                            const n = e.getStreamData(),
                              r = null !== (a = null !== (t = S.get(n.manifestFormat.toLowerCase())) && void 0 !== t ? t : C(n.url)) && void 0 !== a ? a : "";
                            return {
                              uri: n.url,
                              mimeType: r
                            };
                          })(r));
                          break;
                        case s.ERROR:
                          a.removeEventListener(t, n), d = null !== (o = r.getStreamData().errorMessage) && void 0 !== o ? o : "Unknown error", i.error({
                            caller: l,
                            name: P,
                            message: `Failed to load DAI asset ${d}`,
                            critical: !1
                          }), e(null);
                      }
                    };
                  a.addEventListener(t, n);
                };
                if (!(await R("//imasdk.googleapis.com/js/sdkloader/ima3_dai.js", L))) throw new Error("Failed to load IMA SDK");
                i.debug({
                  caller: l,
                  name: P,
                  message: "DAI SDK loaded successfully"
                });
                const m = (null === (s = null === (o = null === window || void 0 === window ? void 0 : window.google) || void 0 === o ? void 0 : o.ima) || void 0 === s ? void 0 : s.dai).api,
                  p = t.coreContainerElement.querySelector(g);
                r = t.coreContainerElement.firstChild, a = new m.StreamManager(p, r);
                const y = new Promise(A);
                n = ((e, t) => {
                  var a, n, r, i;
                  const o = e => {
                      Y.style.zIndex = e ? "1" : "-1";
                    },
                    s = () => {
                      e.statusManager.dispatchNewStatus(E.ADVERTISING_PAUSED, {
                        adType: T.DYNAMIC
                      });
                    },
                    c = () => {
                      e.statusManager.dispatchNewStatus(E.ADVERTISING, {
                        adType: T.DYNAMIC
                      });
                    },
                    u = t => {
                      const a = t ? "addEventListener" : "removeEventListener";
                      O[a](N.ERROR, y), O[a](N.STARTED, D), O[a](N.FIRST_QUARTILE, _), O[a](N.MIDPOINT, b), O[a](N.THIRD_QUARTILE, L), O[a](N.COMPLETE, h), O[a](N.AD_BREAK_STARTED, R), O[a](N.AD_BREAK_ENDED, f), O[a](N.AD_PROGRESS, S), O[a](N.SKIPPED, P), O[a](N.PAUSED, s), O[a](N.RESUMED, c), e.eventDispatcher[a](v.HLSJS_PARSE_FRAG_METADATA, A);
                    },
                    A = e => {
                      e.samples.forEach(e => {
                        t.processMetadata("ID3", e.data, e.pts);
                      });
                    },
                    m = e => {
                      const t = e.track;
                      "metadata" === (null == t ? void 0 : t.kind) && (B.debug({
                        caller: l,
                        name: I,
                        message: "Metadata track is added"
                      }), t.mode = "hidden", t.addEventListener("cuechange", p));
                    },
                    p = e => {
                      const t = e.target;
                      if (null == t ? void 0 : t.activeCues) for (const e of t.activeCues) {
                        B.debug({
                          caller: l,
                          name: I,
                          message: "Track cues are being parsed"
                        });
                        const t = e.value;
                        (null == t ? void 0 : t.key) && (null == O || O.onTimedMetadata({
                          [t.key]: t.data
                        }));
                      }
                    },
                    y = e => {
                      B.error({
                        caller: l,
                        name: I,
                        message: "DAI Ad error",
                        critical: !1
                      }), M(v.AD_ERRORED, e);
                    },
                    D = e => {
                      var t, a, n, r, i, o, s;
                      const d = null === (t = e.getAd) || void 0 === t ? void 0 : t.call(e);
                      if (!d) return void B.error({
                        name: I,
                        message: `Unable to track in-stream Ad! The DAI SDK fired a ${e.type} event with no associated Ad.`,
                        critical: !1
                      });
                      const c = null === (a = d.getAdPodInfo) || void 0 === a ? void 0 : a.call(d),
                        u = null === (n = d.getAdId) || void 0 === n ? void 0 : n.call(d),
                        A = null === (r = d.getDuration) || void 0 === r ? void 0 : r.call(d),
                        m = null === (i = d.getTitle) || void 0 === i ? void 0 : i.call(d),
                        g = null === (o = null == c ? void 0 : c.getAdPosition) || void 0 === o ? void 0 : o.call(c),
                        p = null === (s = null == c ? void 0 : c.getTotalAds) || void 0 === s ? void 0 : s.call(c);
                      B.debug({
                        caller: l,
                        name: I,
                        message: `onAdStarted: ${g} of ${p}`
                      }), M(v.AD_LOADED, d), M(v.AD_STARTED, {
                        id: u,
                        duration: A,
                        title: m,
                        position: g,
                        totalAds: p,
                        isAudio: !1
                      });
                    },
                    h = e => {
                      var t;
                      B.debug({
                        caller: l,
                        name: I,
                        message: "DAI ad completed"
                      });
                      const a = e.getAd();
                      M(v.AD_COMPLETED, null === (t = null == a ? void 0 : a.getAdId) || void 0 === t ? void 0 : t.call(a)), k = null;
                    },
                    R = () => {
                      o(!0), B.debug({
                        caller: l,
                        name: I,
                        message: "DAI ad break started"
                      }), e.statusManager.dispatchNewStatus(E.ADVERTISING, {
                        adType: T.DYNAMIC
                      }), M(v.AD_BREAK_STARTED);
                    },
                    f = () => {
                      o(!1), B.debug({
                        caller: l,
                        name: I,
                        message: "DAI ad break ended"
                      }), k = null, x && clearTimeout(x), x = null, M(v.AD_BREAK_COMPLETED), e.statusManager.dispatchNewStatus(E.PLAYING);
                    },
                    S = e => {
                      const t = e.getStreamData().adProgressData,
                        a = t.adBreakDuration,
                        n = t.duration,
                        r = t.currentTime;
                      M(v.AD_REMAINING_TIME_UPDATED, n - r), a !== U && (U = a, w()), k = t;
                    },
                    _ = () => {
                      M(v.AD_FIRST_QUARTILE);
                    },
                    b = () => {
                      M(v.AD_MIDPOINT);
                    },
                    L = () => {
                      M(v.AD_THIRD_QUARTILE);
                    },
                    P = () => {
                      M(v.AD_SKIPPED);
                    },
                    w = () => {
                      const e = 1e3 * Math.ceil(U);
                      x && clearTimeout(x), x = null, k && (x = setTimeout(C, e));
                    },
                    C = () => {
                      B.debug({
                        caller: l,
                        name: I,
                        message: "DAI ad break ended, determined by ad progress data"
                      }), x && clearTimeout(x), x = null, f();
                    },
                    {
                      dispatchEvent: M
                    } = e.eventDispatcher,
                    N = (null === (n = null === (a = null === window || void 0 === window ? void 0 : window.google) || void 0 === a ? void 0 : a.ima) || void 0 === n ? void 0 : n.dai).api.StreamEvent.Type,
                    O = t;
                  let k, U, x;
                  const B = d(),
                    G = null === (r = e.coreContainerElement) || void 0 === r ? void 0 : r.querySelector(g),
                    Y = null === (i = e.coreContainerElement) || void 0 === i ? void 0 : i.firstChild;
                  return u(!0), (null == G ? void 0 : G.textTracks) && G.textTracks.addEventListener("addtrack", m), {
                    destroy: () => {
                      if (u(!1), o(!1), null == G ? void 0 : G.textTracks) {
                        G.textTracks.removeEventListener("addtrack", m);
                        for (const e of G.textTracks) "metadata" === e.kind && e.removeEventListener("cuechange", p);
                      }
                    }
                  };
                })(t, a);
                const D = null !== (u = null === (c = t.sourceData) || void 0 === c ? void 0 : c.adOrder) && void 0 !== u ? u : "",
                  h = await (async e => {
                    var t;
                    let a;
                    try {
                      a = await (async e => b(_.getDaiParams, e, 1e3, "getDaiParams"))(e);
                    } catch (e) {
                      const a = null !== (t = e.message) && void 0 !== t ? t : e;
                      i.error({
                        caller: l,
                        name: P,
                        message: `Error getting adTagParameters: ${a}`,
                        critical: !1
                      });
                    }
                    return null != a ? a : null;
                  })(D),
                  f = new m.LiveStreamRequest();
                return f.assetKey = e, f.apiKey = "90309C33A86C10147DC061BA9283D5AA9A285B6666AA7915960BE745B99A9D21", h && (f.adTagParameters = h), a.requestStream(f), y;
              } catch (e) {
                return i.error({
                  caller: l,
                  name: P,
                  message: `Error happened loading DAI ${e}`,
                  critical: !0
                }), null;
              }
            })(e.key, t);
          return {
            asset: o,
            destroy: () => {
              for (null == a || a.reset(), null == n || n.destroy(); null == r ? void 0 : r.firstChild;) r.firstChild.remove();
            }
          };
        }], ["medianet", async t => {
          const a = await (async t => {
            var a, n, i;
            let o;
            (null === (a = null == t ? void 0 : t.options) || void 0 === a ? void 0 : a.token) && (o = {
              headers: {
                "x-claims-token": t.options.token
              }
            });
            const s = await r(t.key, o);
            if (s.status === e.ERROR) return null;
            const l = s.response;
            if (!l.url || 0 !== l.errorCode) return null;
            const d = null === (n = l.params) || void 0 === n ? void 0 : n.find(e => "contentType" === e.name);
            return {
              uri: l.url,
              mimeType: null !== (i = null == d ? void 0 : d.value) && void 0 !== i ? i : "vnd.apple.mpegurl"
            };
          })(t);
          return {
            asset: a
          };
        }]]),
        C = e => {
          var t, a;
          const n = null === (a = null === (t = null == e ? void 0 : e.split("?").shift()) || void 0 === t ? void 0 : t.split("/").pop()) || void 0 === a ? void 0 : a.split(".").pop();
          return M(n);
        },
        M = e => {
          var t;
          return e && null !== (t = c.get(e.toLowerCase())) && void 0 !== t ? t : "";
        },
        N = e => {
          if (!(null == e ? void 0 : e.key)) throw h.get("PLAYER_MEDIA_ERROR_KEY");
          if (void 0 !== e.loader && "function" != typeof e.loader) throw h.get("PLAYER_MEDIA_ERROR_LOADER");
        },
        O = e => {
          if (!(null == e ? void 0 : e.format) || (t = e.format, !["audio", "video"].includes(null === (a = null == t ? void 0 : t.toLowerCase) || void 0 === a ? void 0 : a.call(t)))) return h.get("PLAYER_MEDIA_ERROR_FORMAT");
          var t, a;
          if (!Array.isArray(e.assetParsers)) return h.get("PLAYER_MEDIA_ERROR_ASSETPARSERS");
          if (0 === e.assetParsers.length) return h.get("PLAYER_MEDIA_ERROR_ASSETPARSERS");
          try {
            e.assetParsers.forEach(N);
          } catch (e) {
            return e;
          }
        },
        k = new Map([["CLIENTSIDE_IMA_SDK_UNAVAILABLE", {
          name: "CLIENTSIDE_IMA_SDK_UNAVAILABLE",
          message: "Global IMA SDK is not available",
          critical: !1
        }]]),
        U = {
          position: "absolute",
          width: "100%",
          height: "100%",
          top: "0",
          left: "0",
          "z-index": "-1"
        },
        x = "ClientSideAdManager",
        B = (e, t) => {
          const a = e => {
              q.style.zIndex = e ? "1" : "-1";
            },
            n = () => {
              if (ae && Z) for (O.debug({
                name: x,
                message: "Destroy"
              }), a(!1), R(!1), Q = null, null == V || V.removeEventListener(Y.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, f), null == V || V.removeEventListener(Y.AdErrorEvent.Type.AD_ERROR, L), J.removeEventListener("ended", C, !1), J.removeEventListener("playing", S, !1), null == V || V.destroy(), null == F || F.destroy(), null == $ || $.destroy(), clearInterval(j), X = !1, W = !1, ee = !0, Z = !1, ne = !1, re = !1, H && H !== A.ENDED && (e.statusManager.dispatchNewStatus(A.PLAYING), J.play()), H = null; null == q ? void 0 : q.firstChild;) q.firstChild.remove();
            },
            r = e => {
              null == F || F.setVolume(.667 * e);
            },
            i = () => {
              N(u.AD_REMAINING_TIME_UPDATED, (null == F ? void 0 : F.getRemainingTime()) || -1);
            },
            o = e => {
              const t = e.getAd();
              N(u.AD_LOADED, t);
            },
            s = e => {
              var t, a, n, o, s, l, d;
              const c = null === (t = e.getAd) || void 0 === t ? void 0 : t.call(e);
              if (!c) return void O.error({
                name: x,
                message: `Unable to play Ad! The IMA SDK fired a ${e.type} event with no associated Ad.`,
                critical: !1
              });
              const A = null === (a = c.getAdPodInfo) || void 0 === a ? void 0 : a.call(c),
                m = null === (n = c.getAdId) || void 0 === n ? void 0 : n.call(c),
                g = null === (o = c.getDuration) || void 0 === o ? void 0 : o.call(c),
                p = null === (s = c.getTitle) || void 0 === s ? void 0 : s.call(c),
                v = null === (l = null == A ? void 0 : A.getAdPosition) || void 0 === l ? void 0 : l.call(A),
                E = null === (d = null == A ? void 0 : A.getTotalAds) || void 0 === d ? void 0 : d.call(A);
              O.debug({
                name: x,
                message: `onAdStarted ${v} of ${E}`
              }), X = !0;
              let T = !1;
              try {
                T = c.getContentType().indexOf("audio") > -1;
              } catch {}
              J.muted ? r(0) : r(J.volume), j = setInterval(i, 500), ee = !1, N(u.AD_STARTED, {
                id: m,
                duration: g,
                title: p,
                position: v,
                totalAds: E,
                isAudio: T
              });
            },
            l = t => {
              var a;
              const n = t.getAd();
              Q = null, N(u.AD_COMPLETED, null === (a = null == n ? void 0 : n.getAdId) || void 0 === a ? void 0 : a.call(n)), clearInterval(j), e.statusManager.getStatus().to === A.ADVERTISING_PAUSED && D();
            },
            c = t => {
              N(u.AD_BREAK_COMPLETED), W = !1, X = !1, H = null, a(!1), (e => {
                let t = null;
                try {
                  t = e.getAd().getAdPodInfo().getPodIndex();
                } catch (e) {
                  O.error({
                    name: x,
                    message: `IMA unable to get pod index: ${e}`,
                    critical: !1
                  });
                }
                return -1 === t;
              })(t) ? e.statusManager.dispatchNewStatus(A.ENDED) : (e.statusManager.dispatchNewStatus(A.PLAYING), J.play());
            },
            g = t => {
              var n, r, i, o, s;
              W = !0, H = e.statusManager.getStatus().to, e.statusManager.dispatchNewStatus(A.ADVERTISING, {
                adType: m.CLIENTSIDE
              });
              const l = null === (s = null === (i = null === (n = null == t ? void 0 : t.getAd) || void 0 === n ? void 0 : (r = n.call(t)).getAdPodInfo) || void 0 === i ? void 0 : (o = i.call(r)).getPodIndex) || void 0 === s ? void 0 : s.call(o);
              N(u.AD_BREAK_STARTED, l), J.pause(), a(!0);
            },
            p = () => {
              N(u.AD_FIRST_QUARTILE);
            },
            v = () => {
              N(u.AD_MIDPOINT);
            },
            E = () => {
              N(u.AD_THIRD_QUARTILE);
            },
            T = () => {
              N(u.AD_SKIPPED);
            },
            y = () => {
              Q = null, e.statusManager.dispatchNewStatus(A.ADVERTISING_PAUSED, {
                adType: m.CLIENTSIDE
              });
            },
            D = () => {
              e.statusManager.dispatchNewStatus(A.ADVERTISING, {
                adType: m.CLIENTSIDE
              });
            },
            h = () => {
              ee = !0;
            },
            I = e => {
              const t = e.getAdData() || {},
                a = Date.now();
              Q && t.currentTime === Q.currentTime ? a - Q.timestamp > 6e3 && P("Ad Playback Staled") : Q = {
                ...t,
                timestamp: a
              };
            },
            R = e => {
              if (!F) return;
              const t = e ? "addEventListener" : "removeEventListener";
              F[t](G.LOADED, o), F[t](G.STARTED, s), F[t](G.COMPLETE, l), F[t](G.CONTENT_PAUSE_REQUESTED, g), F[t](G.CONTENT_RESUME_REQUESTED, c), F[t](G.FIRST_QUARTILE, p), F[t](G.MIDPOINT, v), F[t](G.THIRD_QUARTILE, E), F[t](G.SKIPPED, T), F[t](G.PAUSED, y), F[t](G.RESUMED, D), F[t](G.ALL_ADS_COMPLETED, h), F[t](G.AD_PROGRESS, I), F[t](Y.AdErrorEvent.Type.AD_ERROR, L);
            },
            f = t => {
              O.debug({
                name: x,
                message: "onAdsManagerLoaded"
              }), F && F.destroy(), F = t.getAdsManager(J, z), J.muted && r(0), R(!0), ne = !1, e.statusManager.getStatus(), re && S();
            },
            S = () => {
              if (Z) if (ne) re = !0;else {
                O.debug({
                  name: x,
                  message: "playAds called"
                }), re = !1;
                try {
                  const {
                    width: t,
                    height: a
                  } = e.sizeManager.getPlayerDimensions();
                  F.init(t, a, Y.ViewMode.NORMAL), F.start();
                } catch (e) {
                  P(`IMA ad failed to initialize: ${e.message}`);
                }
              }
            },
            L = e => {
              let t;
              try {
                t = e.getError().toString();
              } catch {
                t = "Unable to parse error message from getError()";
              }
              P(`Error loading IMA ad: ${t}`);
            },
            P = e => {
              O.error({
                name: x,
                message: e,
                critical: !1
              }), N(u.AD_ERRORED), n();
            },
            w = (t, a) => {
              var n;
              const r = a ? Y.ViewMode.FULLSCREEN : Y.ViewMode.NORMAL;
              null == F || F.resize(t.width, t.height, r), X || "video" !== (null === (n = e.sourceData) || void 0 === n ? void 0 : n.format) || (W = !1);
            },
            C = () => {
              O.debug({
                name: x,
                message: "contentComplete"
              }), null == V || V.contentComplete();
            },
            M = () => {
              var t;
              if (ae && !(null === (t = e.sourceData) || void 0 === t ? void 0 : t.isDAI) && (Z && n(), !e.config.imaSdkInactive)) {
                O.debug({
                  name: x,
                  message: "init"
                });
                try {
                  if (!(() => {
                    var e;
                    return "string" == typeof (null === (e = window.google) || void 0 === e ? void 0 : e.ima.VERSION);
                  })()) throw ae = !1, e.coreContainerElement.removeChild(q), k.get("CLIENTSIDE_IMA_SDK_UNAVAILABLE");
                  (() => {
                    var e;
                    (null == Y ? void 0 : Y.AdsLoader) || (Y = null === (e = window.google) || void 0 === e ? void 0 : e.ima, G = Y.AdEvent.Type, Y.settings.setDisableCustomPlaybackForIOS10Plus(!0), z = new Y.AdsRenderingSettings(), z.restoreCustomPlaybackStateOnAdBreakComplete = !0, z.enablePreloading = !0);
                  })(), $ = new Y.AdDisplayContainer(q, B), V = new Y.AdsLoader($), V.addEventListener(Y.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, f, !1), V.addEventListener(Y.AdErrorEvent.Type.AD_ERROR, L, !1), $.initialize(), Z = !0;
                } catch (e) {
                  P(`Error loading/initializing IMA: ${null == e ? void 0 : e.message}`);
                }
              }
            },
            {
              dispatchEvent: N
            } = e.eventDispatcher,
            O = d(),
            B = t.get("video");
          let G,
            Y,
            H,
            K,
            $,
            V,
            F,
            z,
            j,
            q,
            Q,
            J = B,
            W = !1,
            X = !1,
            Z = !1,
            ee = !0,
            te = !1,
            ae = !0,
            ne = !1,
            re = !1;
          return q = document.createElement("div"), q.className = "phoenix-advertisement", Object.assign(q.style, U), e.coreContainerElement.insertBefore(q, e.coreContainerElement.firstChild), {
            isAdActive: () => W,
            allAdsComplete: () => ee,
            init: M,
            requestAds: async () => {
              var a;
              if (!ae || !e.sourceData || e.config.imaSdkInactive) return;
              if (K = "audio" !== e.sourceData.format || e.sourceData.isLive ? e.sourceData.adUrl ? e.sourceData.adUrl : await (async e => {
                var t, a, n;
                const r = d();
                let i = "";
                if (!(null == e ? void 0 : e.sourceId) || !(null == e ? void 0 : e.adOrder)) return r.error({
                  caller: "Utils",
                  name: "AdUrlGenerator",
                  message: "Required mediaData not supplied",
                  critical: !1
                }), i;
                if (e.isDAI) return r.error({
                  caller: "Utils",
                  name: "AdUrlGenerator",
                  message: "Primary asset is DAI",
                  critical: !1
                }), i;
                const o = {
                  metadata: {
                    id: null !== (t = e.mediaNetId) && void 0 !== t ? t : e.sourceId,
                    adOrder: e.adOrder,
                    adCategoryExclusion: e.adCategoryExclusion,
                    format: null !== (a = e.format) && void 0 !== a ? a : "video",
                    isLive: !!e.isLive
                  }
                };
                try {
                  i = await (async e => b(_.getAdUrl, e, 1e3, "getAdUrl"))(o);
                } catch (e) {
                  const t = null !== (n = e.message) && void 0 !== n ? n : e;
                  r.error({
                    caller: "Utils",
                    name: "AdUrlGenerator",
                    message: `Error getting Ad url: ${t}`,
                    critical: !1
                  });
                }
                return r.debug({
                  caller: "Utils",
                  name: "AdUrlGenerator",
                  message: `AUG returned: ${i}`
                }), null != i ? i : "";
              })(e.sourceData) : "", !K) return O.debug({
                name: x,
                message: "requestAds: Missing adUrl"
              }), void n();
              (() => {
                var a;
                if (!(null === (a = e.sourceData) || void 0 === a ? void 0 : a.format)) return;
                const n = t.get(e.sourceData.format);
                J !== n && (J = n);
              })(), Z || M(), O.debug({
                name: x,
                message: "Sending Ads request"
              });
              let r = !1,
                i = !!J.muted;
              te && (r = !!e.config.isAutoplayAllowed, i = !!e.config.autoplayRequiresMuted, te = !1), e.sizeManager.subscribe(w);
              try {
                const e = new Y.AdsRequest();
                e.setAdWillAutoPlay(r), e.setAdWillPlayMuted(i), e.adTagUrl = K, e.linearAdSlotWidth = 640, e.linearAdSlotHeight = 400, null === (a = null == V ? void 0 : V.requestAds) || void 0 === a || a.call(V, e);
              } catch (e) {
                O.error({
                  name: x,
                  message: `Error requesting an Ad: ${null == e ? void 0 : e.message}`,
                  critical: !1
                }), n();
              }
              J.addEventListener("ended", C, {
                once: !0
              }), J.addEventListener("playing", S, {
                once: !0
              }), ne = !0;
            },
            pause: () => {
              X && F.pause();
            },
            resume: () => {
              null == F || F.resume();
            },
            setVolume: r,
            setAutoplayAttempt: () => {
              te = !0;
            },
            destroy: n
          };
        },
        G = "HLS",
        Y = new Map([["vnd.apple.mpegurl", G], ["application/vnd.apple.mpegurl", G], ["application/x-mpegurl", G]]),
        H = (e, t) => {
          const a = (e, a) => {
              const n = () => {
                  o && clearTimeout(o), t.removeEventListener("loadedmetadata", r), t.removeEventListener("error", i);
                },
                r = () => {
                  n(), e(null);
                },
                i = e => {
                  n();
                  const t = h.get("NATIVE_MEDIA_ERROR");
                  (null == t ? void 0 : t.message) && (t.message += e.message), a(t);
                },
                o = setTimeout(() => {
                  n();
                  const e = h.get("TIMEOUT_ERROR");
                  a(e);
                }, 2e4);
              t.addEventListener("loadedmetadata", r), t.addEventListener("error", i);
            },
            n = d();
          return {
            loadAsset: async r => {
              var i, o, s, l;
              n.debug({
                name: "NativeSourceManager",
                message: "loadAsset call"
              });
              const d = new Promise(a);
              let c;
              c = Number.isInteger(null === (i = e.sourceData) || void 0 === i ? void 0 : i.startTime) ? null === (o = e.sourceData) || void 0 === o ? void 0 : o.startTime : (null === (s = e.sourceData) || void 0 === s ? void 0 : s.hashId) && (null === (l = e.localStorageManager.getMediaById(e.sourceData.hashId)) || void 0 === l ? void 0 : l.currentTime);
              const u = c ? "#t=" + c : "";
              return t.src = r.uri + u, d;
            },
            destroy: () => {
              n.debug({
                name: "NativeSourceManager",
                message: "Destroy"
              });
            }
          };
        },
        K = {
          liveDurationInfinity: !0,
          fragLoadPolicy: {
            default: {
              maxTimeToFirstByteMs: 4e3,
              maxLoadTimeMs: 5e3,
              timeoutRetry: {
                maxRetryDelayMs: 0
              },
              errorRetry: {
                maxRetryDelayMs: 4e3
              }
            }
          },
          playlistLoadPolicy: {
            default: {
              maxTimeToFirstByteMs: 2e3,
              maxLoadTimeMs: 3e3,
              timeoutRetry: {
                maxNumRetry: 1,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
              },
              errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 500,
                maxRetryDelayMs: 2e3
              }
            }
          },
          manifestLoadPolicy: {
            default: {
              maxTimeToFirstByteMs: 2e3,
              maxLoadTimeMs: 1e4,
              timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
              },
              errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1e3,
                maxRetryDelayMs: 8e3
              }
            }
          }
        },
        $ = () => {
          const e = d(),
            t = "Hls.js";
          return {
            debug: a => {
              e.debug({
                caller: t,
                name: "debug",
                message: a
              });
            },
            log: a => {
              e.debug({
                caller: t,
                name: "log",
                message: a
              });
            },
            info: a => {
              e.debug({
                caller: t,
                name: "info",
                message: a
              });
            },
            warn: a => {
              e.debug({
                caller: t,
                name: "warn",
                message: a
              });
            },
            error: a => {
              e.error({
                caller: t,
                name: "error",
                message: a,
                critical: !1
              });
            }
          };
        },
        V = "HlsJsManager",
        F = (e, t) => {
          const a = () => {
              g.debug({
                name: V,
                message: "Destroy"
              }), A && A.isSupported() && m && (c(!1), m.destroy());
            },
            n = () => {
              const e = m.audioTrack;
              return m.audioTracks.map(t => ({
                ...t,
                enabled: t.id === e
              }));
            },
            r = e => {
              m.audioTrack = e;
            },
            i = e => {
              if (e.fatal) switch (e.type) {
                case A.ErrorTypes.NETWORK_ERROR:
                  return m.startLoad(), h.get("HLS_JS_NETWORK_ERROR");
                case A.ErrorTypes.MEDIA_ERROR:
                  return m.recoverMediaError(), h.get("HLS_JS_MEDIA_ERROR");
                default:
                  return h.get("HLS_JS_DEFAULT_ERROR");
              }
            },
            o = (e, t) => {
              let o = 0;
              const s = () => {
                  g.debug({
                    name: V,
                    message: "Level loaded successfuly"
                  }), l();
                  const t = {
                    getAudioTracks: n,
                    enableAudioTrack: r,
                    events: A.Events,
                    on: m.on.bind(m),
                    off: m.off.bind(m),
                    startLoad: m.startLoad.bind(m),
                    handlePlaybackErrors: i
                  };
                  e(t);
                },
                l = () => {
                  m.off(A.Events.ERROR, d), m.off(A.Events.LEVEL_LOADED, s);
                },
                d = (e, n) => {
                  var r, i, s;
                  n.details !== A.ErrorDetails.MANIFEST_LOAD_ERROR && n.details !== A.ErrorDetails.MANIFEST_PARSING_ERROR && n.details !== A.ErrorDetails.MANIFEST_LOAD_TIMEOUT || (g.debug({
                    name: V,
                    message: "Manifest load error"
                  }), l(), m.destroy(), t({
                    name: V,
                    message: `Unable to load manifest. Error details: ${n.details}, code: ${null === (r = n.response) || void 0 === r ? void 0 : r.code}, text: ${null === (i = n.response) || void 0 === i ? void 0 : i.text}`,
                    critical: !0
                  })), n.details === A.ErrorDetails.LEVEL_LOAD_ERROR && 404 === (null === (s = n.response) || void 0 === s ? void 0 : s.code) && (o++, n.fatal && (g.debug({
                    name: V,
                    message: `Level load critical error after ${o} attempts.`
                  }), l(), a(), t({
                    name: V,
                    message: "Unable to load a valid hls level, failing asset load.",
                    critical: !0
                  })));
                };
              m.on(A.Events.ERROR, d), m.on(A.Events.LEVEL_LOADED, s);
            },
            l = (t, a) => {
              e.eventDispatcher.dispatchEvent(u.HLSJS_PARSE_FRAG_METADATA, a);
            },
            c = e => {
              m[e ? "on" : "off"](A.Events.FRAG_PARSING_METADATA, l);
            };
          let A, m;
          const g = d();
          g.debug({
            name: V,
            message: "Initialize"
          });
          const p = (() => {
            const e = s().get("HLSJS_URL") || "https://www.cbc.ca/i/phoenix/libs/hls.js@1.5.8/hls.min.js";
            return R(e, () => !!Object.getOwnPropertyDescriptor(window, "Hls"));
          })();
          return {
            loadAsset: async a => {
              try {
                return await (async () => {
                  var t, a, n, r;
                  const i = await p;
                  if (!i) {
                    const e = h.get("HLS_JS_LOAD_FAILED");
                    throw g.error(e), e;
                  }
                  if (i && !window.Hls.isSupported()) throw h.get("HLS_JS_NOT_SUPPORTED");
                  g.debug({
                    name: V,
                    message: "Create Hls Instance"
                  }), A = window.Hls;
                  const o = {
                    ...K,
                    debug: !!e.config.debug && $()
                  };
                  return Number.isInteger(null === (t = e.sourceData) || void 0 === t ? void 0 : t.startTime) ? o.startPosition = null === (a = e.sourceData) || void 0 === a ? void 0 : a.startTime : (null === (n = e.sourceData) || void 0 === n ? void 0 : n.hashId) && (o.startPosition = null === (r = e.localStorageManager.getMediaById(e.sourceData.hashId)) || void 0 === r ? void 0 : r.currentTime), m = new A(o), null;
                })(), g.debug({
                  name: V,
                  message: `Load the received source ${a.uri}`
                }), c(!0), m.loadSource(a.uri), m.attachMedia(t), new Promise(o);
              } catch (e) {
                throw null == m || m.destroy(), e;
              }
            },
            destroy: a
          };
        },
        z = (e, t) => {
          const a = d();
          let n;
          return {
            loadAsset: async r => (a.debug({
              name: "HlsSourceManager",
              message: "loadAsset call"
            }), n = e.initModule(F, t), n.loadAsset(r)),
            destroy: () => {
              a.debug({
                name: "HlsSourceManager",
                message: "Destroy"
              }), null == n || n.destroy();
            }
          };
        },
        j = (e, t) => {
          const a = e => ({
              asset: {
                uri: e.key,
                mimeType: C(e.key)
              }
            }),
            n = e => !i(e.mimeType) && "" !== t.canPlayType(e.mimeType),
            r = async t => {
              var n;
              const r = null !== (n = null == t ? void 0 : t.loader) && void 0 !== n ? n : a;
              g = await r(t, e);
              const i = g.asset;
              return i ? (l.debug({
                name: "MediaSourceManager",
                message: `Successfully received an asset ${i.uri}`
              }), i) : (l.error({
                name: "MediaSourceManager",
                message: "Failed to get an asset",
                critical: !1
              }), null);
            },
            i = e => !!/(android)/i.test(navigator.userAgent) && Y.get(e.toLowerCase()) === G && (l.debug({
              name: "MediaSourceManager",
              message: "Will not attempt to play natively because current device is Android, and this is HLS media"
            }), !0),
            o = async t => {
              if (l.debug({
                name: "MediaSourceManager",
                message: `Attempting to load natively asset ${t.uri}`
              }), !0 === i(t.mimeType)) return Promise.resolve(!1);
              try {
                return await c.loadAsset(t), l.debug({
                  name: "MediaSourceManager",
                  message: `Successfully loaded asset ${t.uri} natively`
                }), e.eventDispatcher.dispatchEvent(u.ASSET_LOADED, t.uri), Promise.resolve(!0);
              } catch {
                return l.error({
                  name: "MediaSourceManager",
                  message: `Failed to load natively asset ${t.uri}`,
                  critical: !1
                }), Promise.resolve(!1);
              }
            },
            s = async t => {
              l.debug({
                name: "MediaSourceManager",
                message: `Attempting to load asset ${t.uri} with HLS`
              });
              try {
                null == m || m.destroy();
                const a = await m.loadAsset(t);
                return l.debug({
                  name: "MediaSourceManager",
                  message: `Successfully loaded asset ${t.uri} with HLS`
                }), e.eventDispatcher.dispatchEvent(u.ASSET_LOADED, t.uri), a;
              } catch {
                return l.error({
                  name: "MediaSourceManager",
                  message: `Failed to load asset ${t.uri} with HLS`,
                  critical: !1
                }), Promise.resolve(null);
              }
            },
            l = d(),
            c = e.initModule(H, t),
            m = e.initModule(z, t);
          let g,
            p = !1;
          return {
            loadAssets: async () => {
              const t = e.sourceData;
              if (!(null == t ? void 0 : t.assetParsers) || 0 === (null == t ? void 0 : t.assetParsers.length)) return Promise.reject({
                name: "MediaSourceManager",
                message: "No media supplied",
                critical: !0
              });
              if (p) return Promise.reject({
                name: "MediaSourceManager",
                message: "Asset is currently loading",
                critical: !1
              });
              e.statusManager.dispatchNewStatus(A.LOADING), p = !0;
              for (let e = 0; e < t.assetParsers.length; e++) {
                const i = await r(t.assetParsers[e]);
                if (null == i ? void 0 : i.uri) {
                  if (await o(i)) return p = !1, Promise.resolve(null);
                  if (!n(i)) {
                    const e = await (a = i.mimeType, Y.get(a.toLowerCase()) === G ? s : () => Promise.resolve(null))(i);
                    if (e) return p = !1, e;
                  }
                  (null == g ? void 0 : g.destroy) && g.destroy();
                }
              }
              var a;
              return p = !1, Promise.reject(h.get("NO_COMPATIBLE_SOURCES"));
            },
            destroy: () => {
              c.destroy(), m.destroy(), (null == g ? void 0 : g.destroy) && g.destroy(), p = !1, t.removeAttribute("src"), t.load();
            }
          };
        },
        q = (e, t) => function () {
          return e.isInitialized ? t(...arguments) : t.defaultReturn;
        },
        Q = ["captions", "subtitles"],
        J = e => {
          const t = e => {
              const t = e.language || "default",
                a = e.label || "inband";
              return `${t}-${e.kind}-${a}`;
            },
            a = (e, t) => {
              const a = document.createElement("track");
              return a.id = "sidecar_" + t, a.src = e.src, a.srclang = e.srclang, a.kind = e.kind, a.label = e.label, a;
            },
            n = t => {
              const a = T.get(t);
              a && (T.forEach(e => {
                [e.custom.mode, e.original.mode].includes("showing") && (e.custom.mode = "hidden", e.original.mode = "hidden");
              }), a.custom.mode = "showing", a.original.mode = "showing", e.eventDispatcher.dispatchEvent(u.TEXTTRACK_ENABLED, a.original));
            },
            r = (e, t) => {
              var a;
              return {
                original: e,
                custom: {
                  id: t,
                  kind: e.kind,
                  label: e.label,
                  srclang: e.language,
                  mode: null !== (a = e.mode) && void 0 !== a ? a : "hidden"
                }
              };
            },
            i = () => {
              T.forEach(e => {
                e.custom.mode = "hidden", e.original.mode = "hidden";
              });
            },
            o = e => {
              const t = T.get(e);
              if (!t) return;
              v.debug({
                name: "TextTrackManager",
                message: `textTrackOn request with valid text track key ${e}`
              }), n(e);
              const a = {
                isShowing: !0,
                lang: t.custom.srclang,
                kind: t.custom.kind
              };
              E = a;
            };
          o.defaultReturn = void 0;
          const s = () => {
            var t;
            v.debug({
              name: "TextTrackManager",
              message: "textTracksOff request"
            }), i();
            const a = e.localStorageManager.getTextTracks(),
              n = {
                isShowing: !1,
                lang: null !== (t = null == a ? void 0 : a.lang) && void 0 !== t ? t : "",
                kind: null == a ? void 0 : a.kind
              };
            E = n, e.eventDispatcher.dispatchEvent(u.TEXTTRACK_DISABLED);
          };
          s.defaultReturn = void 0;
          const l = e => E.isShowing && E.lang === e.language && e.kind === E.kind,
            c = () => Array.from(T.values()).map(e => e.custom),
            A = e => {
              var t;
              if (!Q.includes(e.kind)) return !1;
              const a = "inBandMetadataTrackDispatchType" in e && !!(null === (t = e.cues) || void 0 === t ? void 0 : t.length);
              return !!e.language && !!e.label || a;
            },
            m = a => {
              if (!a.track || !A(a.track)) return;
              const i = a.track;
              i.mode = "hidden";
              const o = t(i);
              T.set(o, r(i, o)), setTimeout(() => {
                l(i) && n(o), e.eventDispatcher.dispatchEvent(u.TEXTTRACK_AVAILABILITY_CHANGE, c());
              }, 0);
            },
            g = a => {
              if (!a.track) return;
              const n = t(a.track);
              T.delete(n), e.eventDispatcher.dispatchEvent(u.TEXTTRACK_AVAILABILITY_CHANGE, c());
            },
            p = () => {
              var a;
              if (D.removeEventListener("loadedmetadata", p), null == y || y.forEach(e => {
                D.appendChild(e);
              }), h) {
                let i = !1;
                for (let e = 0; e < D.textTracks.length; e++) {
                  const o = D.textTracks[e];
                  if (A(o) && !o.id.startsWith("sidecar_") && (null === (a = o.cues) || void 0 === a ? void 0 : a.length)) {
                    const e = t(o);
                    T.has(e) || (o.mode = "hidden", T.set(e, r(o, e)), l(o) && n(e), i = !0);
                  }
                }
                i && e.eventDispatcher.dispatchEvent(u.TEXTTRACK_AVAILABILITY_CHANGE, c());
              }
            },
            v = d();
          let E = e.localStorageManager.getTextTracks() || {
            isShowing: !1
          };
          const T = new Map();
          let y,
            D,
            h = !1;
          const I = {
            init: t => {
              if (!t || "video" !== t.nodeName.toLowerCase()) return;
              v.debug({
                name: "TextTrackManager",
                message: "Initialization"
              });
              const n = e;
              D = t, Array.isArray(n.sourceData.textTracks) && n.sourceData.textTracks.length && (v.debug({
                name: "TextTrackManager",
                message: "Handle the passed text tracks"
              }), y = n.sourceData.textTracks.map(a)), D.addEventListener("loadedmetadata", p), D.textTracks.addEventListener("addtrack", m), D.textTracks.addEventListener("removetrack", g), I.isInitialized = !0;
            },
            isInitialized: !1,
            publicAPI: {
              textTrackOn: o,
              textTracksOff: s
            },
            destroy: () => {
              !1 !== I.isInitialized && (v.debug({
                name: "TextTrackManager",
                message: "Destroy"
              }), i(), D.textTracks.removeEventListener("addtrack", m), D.textTracks.removeEventListener("removetrack", g), null == y || y.forEach(e => {
                D.contains(e) && D.removeChild(e);
              }), y = [], e.eventDispatcher.dispatchEvent(u.TEXTTRACK_AVAILABILITY_CHANGE, []), T.clear(), I.isInitialized = !1, h = !0);
            }
          };
          return I.publicAPI.textTrackOn = q(I, o), I.publicAPI.textTracksOff = q(I, s), I;
        },
        W = (e, t, a) => {
          const n = () => {
              const e = I.getStatus().to;
              e !== A.PLAYING && e !== A.ADVERTISING && e !== A.ADVERTISING_PAUSED && I.dispatchNewStatus(A.PLAYING);
            },
            r = () => {
              b.debug({
                name: "PlaybackMonitor",
                message: "onPlaying"
              }), n(), g();
            },
            i = () => {
              M && a(), m(), N = 0;
            },
            o = () => {
              I.dispatchNewStatus(A.ERROR), R.dispatchEvent(u.CRITICAL_ERROR, M || h.get("TIMEOUT_ERROR")), m(), a();
            },
            s = () => {
              P && (clearTimeout(P), P = null);
            },
            l = () => {
              L && (clearTimeout(L), L = null, M = null);
            },
            c = () => {
              const e = I.getStatus().to;
              if (e === A.ADVERTISING || e === A.ADVERTISING_PAUSED) return l(), void s();
              N < t.currentTime ? (l(), s(), n()) : N === t.currentTime && (L || (L = setTimeout(o, f)), !P && (null == C ? void 0 : C.startLoad) && (P = setTimeout(() => {
                null == C || C.startLoad();
              }, S)), I.dispatchNewStatus(A.LOADING)), N = t.currentTime;
            },
            m = () => {
              w && clearInterval(w), L && clearTimeout(L), P && clearTimeout(P), w = null, L = null, P = null, M = null;
            },
            g = () => {
              w || (w = setInterval(c, _));
            },
            p = (e, t) => {
              if (!C) return;
              b.debug({
                name: "PlaybackMonitor",
                message: "onHlsError"
              });
              const a = C.handlePlaybackErrors(t);
              (null == a ? void 0 : a.critical) && (M = a);
            },
            v = () => {
              M = h.get("TIMEOUT_ERROR") || null;
            },
            E = () => {
              const t = I.getStatus().to;
              t !== A.ADVERTISING && t !== A.ADVERTISING_PAUSED && (e.statusManager.dispatchNewStatus(A.PAUSED), m());
            },
            T = () => {
              R.dispatchEvent(u.PLAYBACK_SEEKING);
            },
            y = () => {
              R.dispatchEvent(u.PLAYBACK_SEEKED), R.dispatchEvent(u.PLAYBACK_TIMEUPDATED, {
                currentTime: t.currentTime,
                duration: t.duration
              });
            },
            D = e => {
              const a = e ? "addEventListener" : "removeEventListener";
              t[a]("playing", r), t[a]("pause", E), t[a]("ended", i), t[a]("error", v), t[a]("seeking", T), t[a]("seeked", y), C && C[e ? "on" : "off"](C.events.ERROR, p);
            },
            {
              statusManager: I,
              eventDispatcher: R
            } = e,
            f = 35e3,
            S = 8e3,
            _ = 333,
            b = d();
          let L,
            P,
            w,
            C,
            M,
            N = 0;
          return {
            init: e => {
              D(!1), C = e, D(!0);
            },
            startMonitoring: g,
            stopMonitoring: m,
            destroy: () => {
              D(!1), m(), N = 0;
            }
          };
        },
        X = (e, t) => {
          let a, n;
          return function r() {
            const o = Date.now();
            for (var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++) {
              i[_key] = arguments[_key];
            }
            a = clearTimeout(a), !n || o - n >= t ? (e(...i), n = o) : a = setTimeout(r.bind(null, ...i), t - (o - n));
          };
        },
        Z = (e, t) => ({
          start: e,
          end: t
        }),
        ee = e => {
          const t = (e, t) => {
              p = t.details.totalduration, t.details.targetduration && (y = 3 * t.details.targetduration);
            },
            a = e => {
              const a = e ? "addEventListener" : "removeEventListener";
              if (E[a]("progress", s), E[a]("timeupdate", s), E[a]("timeupdate", i), v && v[e ? "on" : "off"](v.events.LEVEL_LOADED, t), e) {
                if (T) return;
                T = setInterval(n, 1e3);
              } else clearInterval(T), T = null;
            },
            n = (() => {
              let e;
              return () => {
                if (Number.isNaN(E.duration)) return;
                if (E.duration !== 1 / 0) return clearInterval(T), void (T = null);
                let t;
                if (E.seekable.length >= 1) {
                  const e = E.seekable.end(E.seekable.length - 1);
                  t = v ? e - y : e;
                } else t = 1 / 0;
                e !== t && (e = t, c(u.LIVE_SYNC_POSITION_CHANGE, e));
              };
            })(),
            r = () => (null == m ? void 0 : m.length) ? E.duration < 1 / 0 ? Z(m.start(0), m.end(0)) : v ? (() => {
              if (p <= 120) return Z(0, 0);
              {
                const e = Math.ceil(m.end(0) - p),
                  t = Math.max(0, e),
                  a = Math.max(m.end(0), p) - y;
                return Z(t, a);
              }
            })() : (() => {
              const e = m.start(0),
                t = m.end(0);
              return t - e <= 120 || t === 1 / 0 ? Z(0, 0) : Z(e, t - y);
            })() : Z(0, 0),
            i = () => {
              o(), c(u.PLAYBACK_TIMEUPDATED, {
                currentTime: E.currentTime,
                duration: E.duration
              });
            },
            o = X(() => c(u.PLAYBACK_THROTTLED_TIMEUPDATED, {
              currentTime: E.currentTime,
              duration: E.duration
            }), 1e3),
            s = () => {
              const e = E.buffered;
              if (m = E.seekable, 0 === e.length) return;
              if (((e, t) => {
                if (!e && !t) return !0;
                if (!e || !t) return !1;
                if (e.length !== t.length) return !1;
                for (let a = 0; a < e.length; a++) {
                  if (e.start(a) !== t.start(a)) return !1;
                  if (e.end(a) !== t.end(a)) return !1;
                }
                return !0;
              })(g, e)) return;
              g = e;
              const t = r();
              c(u.BUFFER_UPDATED, {
                buffers: e,
                seekable: t
              });
            },
            l = () => {
              const e = r(),
                t = Math.ceil(e.end - e.start);
              return 0 !== t && t >= Math.floor(Math.min(y, E.duration));
            };
          l.defaultReturn = !1;
          const {
              dispatchEvent: c
            } = e.eventDispatcher,
            A = d();
          let m, g, p, v, E, T, y;
          const D = {
            init: (e, t) => {
              e && void 0 !== t && (A.debug({
                name: "BufferManager",
                message: "Initialization"
              }), y = 24, E = e, v = t, a(!0), D.isInitialized = !0);
            },
            isInitialized: !1,
            publicAPI: {
              canSeek: l
            },
            destroy: () => {
              !1 !== D.isInitialized && (A.debug({
                name: "BufferManager",
                message: "Destroy"
              }), a(!1), m = {
                length: 0,
                start: () => 0,
                end: () => 0
              }, g = {
                length: 0,
                start: () => 0,
                end: () => 0
              }, D.isInitialized = !1);
            }
          };
          return D.publicAPI.canSeek = q(D, l), D;
        },
        te = e => {
          const t = e => {
              if (s) s[e ? "on" : "off"](s.events.AUDIO_TRACKS_UPDATED, n);else if (null == o ? void 0 : o.audioTracks) {
                const t = e ? "addEventListener" : "removeEventListener";
                o.audioTracks[t]("addtrack", n);
              }
            },
            a = e => e && 0 !== e.length ? e.map(e => ({
              id: String(e.id),
              name: e.name || e.label,
              enabled: void 0 !== e.enabled ? e.enabled : e.default
            })) : [],
            n = () => {
              s ? l = a(s.getAudioTracks()) : o.audioTracks && (l = a(Array.from(o.audioTracks))), e.eventDispatcher.dispatchEvent(u.AUDIOTRACK_AVAILABILITY_CHANGE, r());
            },
            r = () => (c.debug({
              name: "AudioTracksManager",
              message: "Get Audio Tracks"
            }), l),
            i = e => {
              l && 0 !== l.length && l.some(t => t.id === e) && (c.debug({
                name: "AudioTracksManager",
                message: `AudioTrackOn request with valid audiotrack id ${e}`
              }), l.forEach(t => {
                t.enabled = t.id === e;
              }), s ? s.enableAudioTrack(parseInt(e)) : o.audioTracks && Array.from(o.audioTracks).forEach(t => {
                t.enabled = t.id === e;
              }));
            };
          let o, s, l;
          i.defaultReturn = void 0;
          const c = d(),
            A = {
              init: (e, a) => {
                e && void 0 !== a && (c.debug({
                  name: "AudioTracksManager",
                  message: "Initialization"
                }), o = e, s = a, t(!0), n(), A.isInitialized = !0);
              },
              isInitialized: !1,
              publicAPI: {
                audioTrackOn: i
              },
              destroy: () => {
                !1 !== A.isInitialized && (c.debug({
                  name: "AudioTracksManager",
                  message: "Destroy"
                }), t(!1), l = null, A.isInitialized = !1);
              }
            };
          return A.publicAPI.audioTrackOn = q(A, i), A;
        },
        ae = function (e) {
          let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          null !== t && (e.muted = t);
        },
        ne = function (e) {
          let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          null !== t && (e.volume = t);
        },
        re = e => {
          const {
              config: t,
              localStorageManager: a
            } = e,
            n = d();
          let r,
            i = !1;
          return {
            applyConfig: e => {
              if (e === r) return;
              const t = null == r ? void 0 : r.muted,
                a = null == r ? void 0 : r.volume;
              r = e, ae(e, t), ne(e, a);
            },
            init: e => {
              const o = i || void 0 === t.muted ? a.getMuted() : t.muted,
                s = i || void 0 === t.volume ? a.getVolume() : t.volume;
              e.forEach(e => {
                t.autoPlay && e.setAttribute("autoplay", ""), ae(e, o), ne(e, s), !0 === t.enableBrowserControls && e.setAttribute("controls", "true"), "video" === e.nodeName.toLowerCase() && (e.setAttribute("crossorigin", "anonymous"), r = e);
              }), i = !0, n.debug({
                name: "MediaElementController",
                message: "Configs applied to playback element"
              });
            },
            destroy: () => {
              i = !1;
            }
          };
        },
        ie = e => {
          const t = () => {
            z.debug({
              name: "MediaElementController",
              message: "pause request"
            }), Q.isAdActive() ? Q.pause() : U.pause();
          };
          t.defaultReturn = void 0;
          const a = () => {
            z.debug({
              name: "MediaElementController",
              message: "stop request"
            }), R(), x.destroy(), e.statusManager.dispatchNewStatus(A.READY);
          };
          a.defaultReturn = void 0;
          const n = () => (z.debug({
            name: "MediaElementController",
            message: "getVolume request"
          }), U.volume);
          n.defaultReturn = 0;
          const r = e => {
            z.debug({
              name: "MediaElementController",
              message: "setVolume request"
            }), U.volume = e, Q.isAdActive() && Q.setVolume(e);
          };
          r.defaultReturn = void 0;
          const i = () => (z.debug({
            name: "MediaElementController",
            message: "getCurrentTime request"
          }), U.currentTime);
          i.defaultReturn = 0;
          const o = e => {
            z.debug({
              name: "MediaElementController",
              message: "setCurrentTime request"
            }), e >= U.duration && (e = U.duration - .5), U.currentTime = e;
          };
          o.defaultReturn = void 0;
          const s = () => (z.debug({
            name: "MediaElementController",
            message: "getDuration request"
          }), U.duration);
          s.defaultReturn = 0;
          const l = () => (z.debug({
            name: "MediaElementController",
            message: "getMuted request"
          }), U.muted);
          l.defaultReturn = !1;
          const c = t => {
            z.debug({
              name: "MediaElementController",
              message: "setMuted request"
            }), t !== U.muted && (U.muted = t, e.eventDispatcher.dispatchEvent(u.PLAYBACK_MUTEDCHANGE, t), Q.isAdActive() && Q.setVolume(t ? 0 : n()));
          };
          c.defaultReturn = void 0;
          const m = () => (z.debug({
            name: "MediaElementController",
            message: "getPlaybackRate request"
          }), U.playbackRate);
          m.defaultReturn = 1;
          const g = t => {
            z.debug({
              name: "MediaElementController",
              message: "setPlaybackRate request"
            }), U.defaultPlaybackRate = t, U.playbackRate = t, e.eventDispatcher.dispatchEvent(u.PLAYBACK_PLAYBACKSPEEDCHANGE, t);
          };
          g.defaultReturn = void 0;
          const p = t => {
              z.debug({
                name: "MediaElementController",
                message: "setImaSdkInactive request"
              }), e.config.imaSdkInactive = "boolean" == typeof t && t;
            },
            v = () => {
              H || (H = !0, z.debug({
                name: "MediaElementController",
                message: "load request"
              }), k.forEach(e => {
                e.removeAttribute("src"), e.load();
              }), Q.init());
            },
            E = () => {
              z.debug({
                name: "MediaElementController",
                message: "unload request"
              }), a(), e.sourceData = {
                hashId: null,
                format: null,
                assetParsers: null
              };
            };
          E.defaultReturn = void 0;
          const T = async t => {
              z.debug({
                name: "MediaElementController",
                message: "Play request"
              });
              try {
                if (((t, a) => {
                  let n;
                  if (!1 === X.isInitialized ? (v(), a ? (n = O(a), n || (b(a), w())) : t ? w() : n = h.get("NO_MEDIA_TO_PLAY")) : a && (S(), v(), n = O(a), n || (b(a), (e => {
                    if (Y = !1, null === e) return;
                    const t = k.get(e);
                    t !== U && (U.setAttribute("hidden", "true"), t.removeAttribute("hidden"), F.applyConfig(t), U = t);
                  })(a.format), _(), e.localStorageManager.initMedia(U))), n) throw n;
                })(null == C ? void 0 : C.sourceData, t), Q.isAdActive()) return Q.resume(), Promise.resolve();
                x.startMonitoring(), Y || (await y()), await U.play();
              } catch (e) {
                const t = D(e);
                return I(t);
              }
              return Promise.resolve();
            },
            y = async () => {
              z.debug({
                name: "MediaElementController",
                message: "InitialPlay call"
              }), e.eventDispatcher.dispatchEvent(u.PLAYBACK_INITIALPLAY);
              try {
                await Q.requestAds(), e.sizeManager.init(U);
                const t = await G.loadAssets();
                x.init(t), $.init(U, t), V.init(U, t), Y = !0, H = !1;
              } catch (e) {
                if (e.critical) return Promise.reject(e);
              }
              return Promise.resolve();
            },
            D = e => Object.getOwnPropertyDescriptor(e, "critical") ? e : "NotAllowedError" === e.name || "NotSupportedError" === e.name ? {
              critical: !1,
              name: "MediaElementController",
              message: e.message
            } : e,
            I = t => (Object.getOwnPropertyDescriptor(t, "critical") && (H = !1, null == Q || Q.destroy(), null == x || x.stopMonitoring(), !0 === t.critical ? (e.eventDispatcher.dispatchEvent(u.CRITICAL_ERROR, t), e.statusManager.dispatchNewStatus(A.ERROR)) : e.statusManager.dispatchNewStatus(A.READY)), z.error(t), Promise.resolve(t.message)),
            R = () => {
              p(!1), K.destroy(), $.destroy(), null == V || V.destroy(), Q.destroy(), G.destroy(), K.init(U), Y = !1;
            },
            f = () => {
              R();
            },
            S = () => {
              e.sizeManager.destroy(), Q.destroy(), null == G || G.destroy(), null == x || x.destroy(), K.destroy(), $.destroy(), V.destroy();
            },
            _ = () => {
              x = C.initModule(W, U, f), G = C.initModule(j, U), K.init(U);
            },
            b = t => {
              var a;
              t !== e.sourceData && (e.sourceData = {
                ...t,
                hashId: (a = t.assetParsers, null === a ? null : function (e) {
                  let t = 5381,
                    a = e.length;
                  for (; a;) t = 33 * t ^ e.charCodeAt(--a);
                  return t >>> 0;
                }(a.reduce((e, t) => e + t.key, "")))
              }, C = e);
            },
            L = () => {
              e.eventDispatcher.dispatchEvent(u.PLAYBACK_VOLUMECHANGE, n());
            },
            P = () => {
              Q.allAdsComplete() && e.statusManager.dispatchNewStatus(A.ENDED);
            },
            w = () => {
              var t;
              z.debug({
                name: "MediaElementController",
                message: "Initialization"
              }), (null === (t = C.sourceData) || void 0 === t ? void 0 : t.format) && (U = k.get(C.sourceData.format), e.localStorageManager.initMedia(U), _(), z.debug({
                name: "MediaElementController",
                message: "Removing hidden attribute from playbackElement"
              }), U.hasAttribute("hidden") && U.removeAttribute("hidden"), X.isInitialized = !0);
            };
          let C;
          const M = e.coreContainerElement,
            N = e.config,
            k = new Map();
          let U,
            x,
            G,
            Y = !1,
            H = !1;
          const K = e.initModule(J),
            $ = e.initModule(ee),
            V = e.initModule(te),
            F = e.initModule(re),
            z = d();
          (() => {
            const e = document.createElement("video"),
              t = document.createElement("audio");
            e.setAttribute("playsinline", ""), e.setAttribute("data-name", "phoenix-playback-element"), e.preload = "metadata", e.style.setProperty("width", "100%"), e.style.setProperty("height", "100%"), e.setAttribute("hidden", "true"), t.setAttribute("hidden", "true"), t.preload = "metadata", e.addEventListener("volumechange", L), t.addEventListener("volumechange", L), e.addEventListener("ended", P), t.addEventListener("ended", P), z.debug({
              name: "MediaElementController",
              message: "Playback element successfully created"
            }), k.set("video", e), k.set("audio", t), F.init([e, t]), U = e, M.appendChild(U), M.appendChild(t);
          })();
          const Q = B(e, k),
            X = {
              init: e => {
                (e => {
                  const t = O(e);
                  return !t || (z.error(t), !1);
                })(e) && (N.autoPlay && N.isAutoplayAllowed && (Q.setAutoplayAttempt(), v()), b(e), N.autoPlay && (w(), T()));
              },
              isInitialized: !1,
              publicAPI: {
                play: T,
                load: v,
                pause: t,
                stop: a,
                unload: E,
                getVolume: n,
                setVolume: r,
                getCurrentTime: i,
                setCurrentTime: o,
                getDuration: s,
                getMuted: l,
                setMuted: c,
                canSeek: $.publicAPI.canSeek,
                audioTrackOn: V.publicAPI.audioTrackOn,
                textTrackOn: K.publicAPI.textTrackOn,
                textTracksOff: K.publicAPI.textTracksOff,
                getPlaybackRate: m,
                setPlaybackRate: g,
                setImaSdkInactive: p
              },
              destroy: () => {
                var e, t, a, n;
                z.debug({
                  name: "MediaElementController",
                  message: "Destroy"
                }), S(), F.destroy(), k.forEach(e => {
                  M.removeChild(e);
                }), null === (e = k.get("video")) || void 0 === e || e.removeEventListener("volumechange", L), null === (t = k.get("audio")) || void 0 === t || t.removeEventListener("volumechange", L), null === (a = k.get("video")) || void 0 === a || a.removeEventListener("ended", P), null === (n = k.get("audio")) || void 0 === n || n.removeEventListener("ended", P);
              }
            };
          return X.publicAPI.play = T, X.publicAPI.load = v, X.publicAPI.pause = q(X, t), X.publicAPI.stop = q(X, a), X.publicAPI.unload = q(X, E), X.publicAPI.getVolume = q(X, n), X.publicAPI.setVolume = q(X, r), X.publicAPI.getCurrentTime = q(X, i), X.publicAPI.setCurrentTime = q(X, o), X.publicAPI.getDuration = q(X, s), X.publicAPI.getMuted = q(X, l), X.publicAPI.setMuted = q(X, c), X.publicAPI.getPlaybackRate = q(X, m), X.publicAPI.setPlaybackRate = q(X, g), X.publicAPI.setImaSdkInactive = p, X;
        },
        oe = () => {
          const e = d(),
            t = Object.values(u),
            a = new Map([]);
          return {
            addEventListener: (n, r, i) => {
              if (t.includes(n)) {
                if (a.get(n)) {
                  const e = a.get(n),
                    t = null != e ? e : [];
                  i ? t.unshift(r) : t.push(r), a.set(n, t);
                } else {
                  const e = [r];
                  a.set(n, e);
                }
              } else e.error({
                name: "EventDispatcher",
                message: `addEventListener ${n} is not a valid event`,
                critical: !1
              });
            },
            removeEventListener: (n, r) => {
              if (t.includes(n)) {
                const e = a.get(n),
                  t = null == e ? void 0 : e.filter(e => e !== r);
                t ? a.set(n, t) : a.delete(n);
              } else e.error({
                name: "EventDispatcher",
                message: `removeEventListener ${n} is not a valid event`,
                critical: !1
              });
            },
            dispatchEvent: (t, n) => {
              if (e.debug({
                name: "EventDispatcher",
                message: `Dispatch event ${t}`
              }), t) {
                const e = a.get(t);
                e && e.forEach(e => {
                  e(n);
                });
              }
            },
            destroy: () => {
              a.clear();
            }
          };
        },
        se = e => {
          const {
              eventDispatcher: t
            } = e,
            a = {
              from: A.READY,
              to: A.READY
            },
            n = d();
          n.debug({
            name: "StatusManager",
            message: "Initialization"
          });
          let r = a;
          return {
            dispatchNewStatus: (e, a) => {
              if (r.to === e) return;
              const i = {
                from: r.to,
                to: e
              };
              a && (i.data = {
                ...a
              }), n.debug({
                name: "StatusManager",
                message: `Status change from ${i.from} to ${i.to}`
              }), t.dispatchEvent(u.STATUS_CHANGE, i), r = i;
            },
            getStatus: () => r,
            destroy: () => {
              n.debug({
                name: "StatusManager",
                message: "Destroy"
              }), r = a;
            }
          };
        },
        le = e => {
          const t = () => {
              null == o || o.removeEventListener("playing", t), e.eventDispatcher.dispatchEvent(v.MEDIA_ASPECT_RATIO_AVAILABLE, a(o));
            },
            a = e => parseFloat((e.videoWidth / e.videoHeight).toFixed(3)),
            n = (t, a) => {
              i.width = null != t ? t : e.coreContainerElement.offsetWidth, i.height = null != a ? a : e.coreContainerElement.offsetHeight;
            },
            r = document,
            i = {
              width: 0,
              height: 0
            };
          let o;
          const s = [],
            l = new ResizeObserver(t => {
              var a;
              const o = Array.isArray(t) && (null === (a = t[0]) || void 0 === a ? void 0 : a.contentRect) || {
                width: void 0,
                height: void 0
              };
              n(o.width, o.height);
              const l = (r.fullscreenElement || r.webkitFullscreenElement || r.mozFullScreenElement || r.msFullscreenElement) === e.externalContainerElement;
              s.forEach(e => e(i, l));
            });
          return e.coreContainerElement.style.setProperty("position", "relative"), e.coreContainerElement.style.setProperty("width", "100%"), e.coreContainerElement.style.setProperty("height", "100%"), e.coreContainerElement.style.setProperty("overflow", "hidden"), n(), {
            subscribe: e => {
              s.push(e);
            },
            init: a => {
              l.observe(e.coreContainerElement), o = a, "video" === o.nodeName.toLowerCase() && o.addEventListener("playing", t);
            },
            getPlayerDimensions: () => i,
            destroy: () => {
              l.unobserve(e.coreContainerElement), l.disconnect(), null == o || o.removeEventListener("playing", t), o = null;
            }
          };
        },
        de = "wpp-phoenix-core",
        ce = e => {
          const t = () => {
              const e = null == D ? void 0 : D.getItem(de);
              return e ? JSON.parse(e) : {};
            },
            a = e => {
              if (!D) return;
              const a = t();
              a.muted = e, o(a);
            },
            n = () => {
              if (!D) return;
              const e = t();
              e.textTrack && (delete e.textTrack, o(e));
            },
            r = e => {
              if (!D || !e) return;
              const a = t();
              a.textTrack = {
                isShowing: !0,
                lang: e.language,
                kind: e.kind
              }, o(a);
            },
            i = (e, a, n) => {
              if (!D) return;
              if (n === 1 / 0 || isNaN(n)) return;
              const r = t(),
                i = r.media || {};
              a / n >= .9 && (a = 0), r.media = Object.assign(i, {
                [`${e}`]: {
                  currentTime: a,
                  lastModified: Date.now()
                }
              }), o(r);
            },
            o = e => {
              D && D.setItem(de, JSON.stringify(e));
            },
            s = t => {
              const a = t ? "addEventListener" : "removeEventListener";
              v[a]("emptied", l), v[a]("loadedmetadata", d), v[a]("timeupdate", c), v[a]("volumechange", m), v[a]("ended", g), e.eventDispatcher[a](u.TEXTTRACK_ENABLED, r), e.eventDispatcher[a](u.TEXTTRACK_DISABLED, n);
            },
            l = () => {
              i(E.hashId, E.currentTime, E.duration), T = !1;
            },
            d = () => {
              null !== p.hashId && (E.hashId = p.hashId, E.duration = v.duration, !1 !== e.config.muted && !0 !== e.config.muted || a(e.config.muted));
            },
            c = () => {
              A();
            },
            A = X(() => {
              E.currentTime = v.currentTime, !T && v.currentTime / v.duration * 100 >= 50 && E.sourceId && ((e, a) => {
                if (!D || !e || a) return;
                const n = t(),
                  r = n.watchedIds || [],
                  i = e.toString();
                r.includes(i) || r.push(i), r.length > 10 && r.shift(), n.watchedIds = r, o(n), T = !0;
              })(E.sourceId, E.isLive);
            }, 5e3),
            m = () => {
              a(v.muted), (e => {
                if (!D) return;
                const a = t();
                a.volume = e, o(a);
              })(v.volume);
            },
            g = () => {
              null !== p.hashId && i(p.hashId, 0, v.duration);
            };
          let p, v;
          const E = {
            currentTime: 0,
            duration: NaN,
            hashId: NaN,
            sourceId: "",
            isLive: !1
          };
          let T = !1,
            y = null,
            D = window && window.localStorage instanceof Storage ? window.localStorage : null;
          return D && (() => {
            const e = t();
            for (const t in e.media) {
              const a = e.media[t].lastModified;
              a && a < Date.now() - 1728e5 && delete e.media[t];
            }
            o(e);
          })(), {
            initMedia: t => {
              t && e.sourceData && (v = t, p = e.sourceData, s(!0), null !== y && window.removeEventListener("beforeunload", y), y = (() => {
                const e = () => {
                  window.removeEventListener("beforeunload", e), p.hashId && i(p.hashId, v.currentTime, v.duration);
                };
                return e;
              })(), window.addEventListener("beforeunload", y));
            },
            getMediaById: e => {
              if (!D) return null;
              const a = t();
              return a.media && a.media[e] || null;
            },
            getWatchedMediaIds: () => {
              if (!D) return [];
              const e = t();
              return e.watchedIds ? e.watchedIds : [];
            },
            getVolume: () => {
              var e;
              return D && null !== (e = t().volume) && void 0 !== e ? e : null;
            },
            getMuted: () => {
              var e;
              return D && null !== (e = t().muted) && void 0 !== e ? e : null;
            },
            getTextTracks: () => D && t().textTrack || null,
            getPlayNextEnabled: () => {
              var e;
              return !D || null === (e = t().playNextEnabled) || void 0 === e || e;
            },
            setPlayNextEnabled: e => {
              if (!D || "boolean" != typeof e) return;
              const a = t();
              a.playNextEnabled = e, o(a);
            },
            setCurrentMedia: e => {
              E.sourceId = e.sourceId, E.isLive = e.isLive;
            },
            destroy: () => {
              D = null, y && window.removeEventListener("beforeunload", y), y = null, s(!1);
            }
          };
        },
        ue = (e, t) => {
          const a = {
            config: e
          };
          var n;
          a.initModule = (n = a, function (e, t) {
            for (var _len2 = arguments.length, a = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              a[_key2 - 2] = arguments[_key2];
            }
            return t ? e(n, t, ...a) : e(n);
          });
          const r = d(e.debug);
          r.debug({
            name: "PhoenixCore",
            message: "Initialization"
          }), r.debug({
            name: "PhoenixCore",
            message: "Version: " + y
          });
          const i = a.initModule(oe);
          a.eventDispatcher = i;
          const o = a.initModule(se);
          a.statusManager = o;
          const s = a.initModule(ce);
          a.localStorageManager = s, (e => {
            if (!(null == e ? void 0 : e.containerNode)) throw h.get("PLAYER_CONFIG_ERROR");
          })(e), r.debug({
            name: "PhoenixCore",
            message: "Config successfully validated"
          });
          const l = (e => {
              const t = e.containerNode;
              if (!(null == t ? void 0 : t.appendChild)) throw h.get("PLAYER_INJECTION_ERROR");
              return t;
            })(e),
            c = document.createElement("div");
          c.classList.add("phoenix-core-container"), c.setAttribute("data-core-version", y), l.appendChild(c), a.externalContainerElement = l, a.coreContainerElement = c;
          const u = a.initModule(le);
          a.sizeManager = u;
          const A = Math.floor(1e8 + 9e8 * Math.random());
          r.debug({
            name: "PhoenixCore",
            message: "Generate uid: " + A
          });
          const m = a.initModule(ie);
          return t && m.init(t), {
            uid: A,
            destroy: () => {
              r.debug({
                name: "PhoenixCore",
                message: "Destroy"
              }), m.destroy(), o.destroy(), s.destroy(), i.destroy();
            },
            media: m.publicAPI,
            on: i.addEventListener,
            off: i.removeEventListener,
            trigger: i.dispatchEvent,
            getStatus: o.getStatus,
            localStorageManager: s
          };
        },
        Ae = e => {
          var t, a;
          if (!e) return;
          const n = "platform-dai" === (null === (a = null === (t = null == e ? void 0 : e.assets) || void 0 === t ? void 0 : t[0]) || void 0 === a ? void 0 : a.type);
          return {
            assetParsers: (r = e.assets, Array.isArray(r) && 0 !== r.length ? r.reduce((e, t) => {
              var a;
              return (null == (a = t) ? void 0 : a.key) && a.type && w.get(a.type) && e.push({
                key: t.key,
                options: t.options,
                loader: w.get(t.type)
              }), e;
            }, []) : []),
            format: e.format,
            adUrl: e.adUrl,
            adOrder: e.adOrder,
            adCategoryExclusion: e.adCategoryExclusion,
            textTracks: e.textTracks,
            startTime: e.startTime,
            sourceId: e.sourceId,
            mediaNetId: e.mediaNetId,
            isLive: e.isLive,
            isDAI: n
          };
          var r;
        },
        me = t => {
          const a = e => {
              const a = e ? "on" : "off";
              t[a](v.STATUS_CHANGE, i, !0), t[a](v.PLAYBACK_THROTTLED_TIMEUPDATED, s);
            },
            n = () => {
              D = 1, y = !1, T = null;
            },
            i = e => {
              e.to === E.ENDED ? (n(), a(!1), t.trigger(v.CHAPTER_COMPLETE)) : e.to === E.READY && n();
            },
            o = (e, t) => !(!e || !t) && e.startTime === t.startTime && e.endTime === t.endTime && e.programTitle === t.programTitle,
            s = (() => {
              let e = !1;
              return async () => {
                const a = t.getStatus().to;
                if (!0 === e || a !== E.PLAYING) return;
                const n = A();
                let r = null;
                if (n || (e = !0, r = await c(), T = r, e = !1), !n && !r) return y && t.trigger(v.CHAPTER_COMPLETE), void m();
                y && r && (y = !1, t.trigger(v.CHAPTER_COMPLETE));
                const i = A();
                if (!y && i) {
                  y = !0;
                  const e = u(T);
                  g.debug({
                    caller: l,
                    name: "ChapterManager - liveRadio",
                    message: `Triggering chapter start: ${JSON.stringify(e)}`
                  }), t.trigger(v.CHAPTER_START, e), D++;
                }
              };
            })(),
            c = async () => {
              try {
                const t = await (async t => {
                  try {
                    const a = (e => {
                      if (e) return {
                        query: `{\n            onNow: linearScheduleOnNow(callSign: "${e}") {\n                programTitle\n                startTime\n                endTime\n                program {\n                    thumbnail\n                }\n            }\n            upNext: linearScheduleUpNext(callSign: "${e}") {\n                programTitle\n                startTime\n                endTime\n                program {\n                    thumbnail\n                }\n            }\n        }`
                      };
                    })(t);
                    if (!a) throw new Error("No GQL query specified");
                    const n = await (async t => {
                        var a, n;
                        const i = {
                            headers: {
                              "Content-Type": "application/json",
                              "X-Cache-By-Country": "true"
                            },
                            method: "POST",
                            body: JSON.stringify(t)
                          },
                          o = await r("https://www.cbc.ca/graphql", i);
                        if (o.status === e.ERROR) {
                          const e = null !== (n = null === (a = o.response) || void 0 === a ? void 0 : a.message) && void 0 !== n ? n : "Unknown Error";
                          throw new Error(`GQL Fetch Error: ${e}`);
                        }
                        return o;
                      })(a),
                      i = n.response.data;
                    if (!(null == i ? void 0 : i.onNow)) throw new Error("Incorrect onNowNextPayload returned");
                    return i;
                  } catch (e) {
                    const t = new Error(`Failed to get Live Radio On Now/Next Item: ${e.message}`);
                    return Promise.reject(t);
                  }
                })(p);
                return (e => {
                  if (!(null == e ? void 0 : e.onNow) || !(null == e ? void 0 : e.upNext)) return !1;
                  const t = e.upNext;
                  return !o(t, T);
                })(t) ? o(t.onNow, T) && null !== t.upNext ? t.upNext : t.onNow : null;
              } catch {
                return null;
              }
            },
            u = e => {
              var a;
              return {
                length: (e.endTime - e.startTime) / 1e3,
                position: D,
                startTime: e.startTime,
                playhead: t.media.getCurrentTime(),
                show: e.programTitle ? e.programTitle : "",
                thumbnail: (null === (a = e.program) || void 0 === a ? void 0 : a.thumbnail) ? e.program.thumbnail : ""
              };
            },
            A = () => !(!((null == T ? void 0 : T.programTitle) && (null == T ? void 0 : T.startTime) && (null == T ? void 0 : T.endTime)) || Date.now() >= T.endTime),
            m = () => {
              n(), a(!1);
            },
            g = d();
          let p,
            T = null,
            y = !1,
            D = 1;
          return {
            init: e => {
              g.debug({
                caller: l,
                name: "ChapterManager - liveRadio",
                message: `Init with callSign ${null == e ? void 0 : e.callSign}`
              }), e.callSign && (p = e.callSign, a(!0));
            },
            destroy: m
          };
        },
        ge = e => {
          const t = new Date(e),
            a = t.getFullYear(),
            n = t.getMonth() + 1;
          return a + "-" + (n < 10 ? "0" + n : n.toString()) + "-" + (t.getDate() < 10 ? "0" + t.getDate() : t.getDate());
        },
        pe = e => {
          const t = Number.parseFloat(e),
            a = Number.isNaN(t) ? 0 : t;
          return Math.round(100 * (a + Number.EPSILON)) / 100;
        },
        ve = e => {
          const t = t => {
              const n = t ? "on" : "off";
              e[n](v.STATUS_CHANGE, a), e[n](v.PLAYBACK_TIMEUPDATED, r);
            },
            a = t => {
              m = t.to, t.to === E.ENDED && n(), t.to === E.PLAYING && y && (y = !1, e.on(v.PLAYBACK_TIMEUPDATED, r));
            },
            n = () => {
              e.off(v.PLAYBACK_TIMEUPDATED, r), y = !0, T = !1, p = 0, o(g.length - 1);
            },
            r = e => {
              const {
                  currentTime: t
                } = e,
                a = u(t);
              if (-1 !== a) return T || m !== E.PLAYING ? void (a !== p && (o(p), p = a, i(a))) : (i(a), T = !0, void (p = a));
              A.debug({
                caller: l,
                name: "ChapterManager - default - onTimeUpdated",
                message: `Could not determine chapter index for ${t}`
              });
            },
            i = t => {
              A.debug({
                caller: l,
                name: "ChapterManager - default - chapterStart",
                message: `Chapter ${t + 1} started`
              }), e.trigger(v.CHAPTER_START, s(t));
            },
            o = t => {
              A.debug({
                caller: l,
                name: "ChapterManager - default - chapterComplete",
                message: `Chapter ${t + 1} ended`
              }), e.trigger(v.CHAPTER_COMPLETE);
            },
            s = t => {
              const a = g[t];
              return {
                length: c(t),
                position: t + 1,
                startTime: a.startTime,
                playhead: e.media.getCurrentTime(),
                show: a.name ? a.name : "",
                thumbnail: ""
              };
            },
            c = t => {
              if (t < 0 || t >= g.length) return -1;
              const a = g[t];
              let n;
              if (t === g.length - 1) {
                const t = e.media.getDuration();
                n = pe(t) - a.startTime;
              } else n = g[t + 1].startTime - a.startTime;
              return n <= 0 && (n = -1), n;
            },
            u = e => g.findIndex((t, a, n) => !(e < t.startTime || n[a + 1] && e >= n[a + 1].startTime)),
            A = d();
          let m,
            g = [],
            p = 0,
            T = !1,
            y = !1;
          return {
            init: a => {
              var n;
              A.debug({
                caller: l,
                name: "ChapterManager - default",
                message: "Init"
              }), (null === (n = null == a ? void 0 : a.chapters) || void 0 === n ? void 0 : n.length) && 0 !== a.chapters.length && (e => !!Array.isArray(e) && !e.some(e => !e.startTime && !e.name))(a.chapters) ? g = a.chapters : (A.debug({
                caller: l,
                name: "ChapterManager - default",
                message: "Init - invalid chapters supplied"
              }), g.push((e => {
                var t;
                return {
                  startTime: 0,
                  name: null !== (t = e.showName) && void 0 !== t ? t : ""
                };
              })(a))), m = e.getStatus().to, t(!0);
            },
            destroy: () => {
              t(!1);
            }
          };
        },
        Ee = 6e4,
        Te = {
          ...E,
          SCHEDULED: "SCHEDULED",
          TIMEDOUT: "TIMEDOUT",
          CRITICAL_ERROR: "CRITICAL_ERROR"
        },
        ye = 2147483647;
      var De = a(241);
      const he = (() => {
          let t;
          return () => (t || (t = (() => {
            let t;
            return {
              getUser: async () => (t || (t = await (() => {
                let t = !1;
                const a = s().get("UIE_CURRENT_USER_URL") || "https://uie.data.cbc.ca/v0/current_user",
                  n = d();
                return async () => {
                  var i, o;
                  try {
                    if (!t) {
                      t = !0;
                      const s = await r(a);
                      if (s.status === e.ERROR) {
                        const e = null !== (o = null === (i = s.response) || void 0 === i ? void 0 : i.message) && void 0 !== o ? o : "Unknown Error";
                        throw n.debug({
                          caller: l,
                          name: "User Manager",
                          message: e
                        }), new Error(e);
                      }
                    }
                    return function () {
                      var e, t;
                      const a = window.document.cookie.split(";");
                      let n, r;
                      for (let i = 0; i < a.length; i++) {
                        const o = a[i].split("="),
                          s = null === (t = null === (e = null == o ? void 0 : o[0]) || void 0 === e ? void 0 : e.trim) || void 0 === t ? void 0 : t.call(e),
                          l = {
                            type: s,
                            id: o[1]
                          };
                        "cbc_plus" === s ? n = l : "cbc_visitor" === s && (r = l);
                      }
                      return n || r || null;
                    }();
                  } catch {
                    return null;
                  }
                };
              })()()), t)
            };
          })()), t);
        })(),
        Ie = async (t, a) => {
          const n = e => {
              const t = e.media.play,
                a = e.media.stop;
              return {
                ...e.media,
                play: async a => {
                  if (a) {
                    u = !1, c = a, r(e);
                    const n = Ae(a);
                    return t(n);
                  }
                  return u || r(e), t();
                },
                stop: () => (u = !1, o(), a())
              };
            },
            r = a => {
              if (!c || u) return;
              let n, r, o, A, m;
              const p = Array.from(g.entries());
              (null == p ? void 0 : p.length) ? (n = g.get("ChapterManager"), r = g.get("Analytics"), o = g.get("UpcomingLiveManager"), A = g.get("RecommendationsFetcher"), m = g.get("MediaNetPlaybackLog")) : (n = (e => {
                let t;
                const a = d();
                return {
                  init: n => {
                    n.isLive && n.callSign && "audio" === n.format ? (t = me(e), a.debug({
                      caller: l,
                      name: "ChapterManager",
                      message: "Init Live Radio Chapter Manager"
                    })) : (t = ve(e), a.debug({
                      caller: l,
                      name: "ChapterManager",
                      message: "Init Default Chapter Manager"
                    })), t.init(n);
                  },
                  destroy: () => {
                    t && t.destroy();
                  }
                };
              })(a), r = (e => {
                const t = e => e + .5 | 0,
                  a = t => {
                    const a = t ? "on" : "off";
                    e[a](v.PLAYBACK_INITIALPLAY, r, !0), e[a](v.STATUS_CHANGE, i, !0), e[a](v.PLAYBACK_TIMEUPDATED, u), e[a](v.AD_BREAK_STARTED, A), e[a](v.AD_BREAK_COMPLETED, m), e[a](v.AD_STARTED, g), e[a](v.AD_COMPLETED, p), e[a](v.PLAYBACK_SEEKING, y), e[a](v.PLAYBACK_SEEKED, D), e[a](v.CHAPTER_START, h), e[a](v.CHAPTER_COMPLETE, I), e[a](v.TEXTTRACK_ENABLED, R), e[a](v.TEXTTRACK_DISABLED, R), e[a](v.AD_ERRORED, T);
                  },
                  n = e => {
                    var t, a, n;
                    const r = (e => {
                      var t, a, n, r, i, o, s, l, d;
                      const c = null !== (a = null !== (t = e.mediaId) && void 0 !== t ? t : e.sourceId) && void 0 !== a ? a : "",
                        u = e.mediaId ? "mediaId" : e.source,
                        A = null !== (n = e.feature) && void 0 !== n ? n : {},
                        m = {
                          uid: null == c ? void 0 : c.toString(),
                          source: null != u ? u : "",
                          seasonnumber: null !== (r = e.season) && void 0 !== r ? r : "",
                          episodenumber: null !== (i = e.episode) && void 0 !== i ? i : "",
                          show: e.showName && !e.isLive ? e.showName : "",
                          region: null !== (o = e.region) && void 0 !== o ? o : "",
                          sport: null !== (s = e.sport) && void 0 !== s ? s : "",
                          genre: null !== (l = e.genre) && void 0 !== l ? l : "",
                          sponsorname: null !== (d = e.brandedSponsorName) && void 0 !== d ? d : "",
                          keywords: {
                            tags: e.tags,
                            concepts: e.concepts
                          }
                        };
                      return Object.keys(A).length && (m.feature = A), m;
                    })(e);
                    return {
                      streamtitle: null !== (t = e.title) && void 0 !== t ? t : "",
                      audiovideo: e.format,
                      contentarea: null !== (a = e.contentArea) && void 0 !== a ? a : "",
                      type: null !== (n = e.type) && void 0 !== n ? n : "",
                      totalchapters: (null == P ? void 0 : P.isLive) ? "1" : (null == P ? void 0 : P.chapters) && Array.isArray(null == P ? void 0 : P.chapters) && 0 !== (null == P ? void 0 : P.chapters.length) ? P.chapters.length.toString() : "1",
                      airDate: e.pubDate ? ge(e.pubDate) : "",
                      ...r
                    };
                  },
                  r = () => {
                    _.debug({
                      caller: l,
                      name: "Analytics",
                      message: "onInitialPlay"
                    }), x = 0, C = !0, f("videoLoad", S, (() => {
                      if (P) return {
                        streamType: P.isLive ? "live" : "vod",
                        playhead: x,
                        closedCaptionEnabled: B,
                        length: (null == P ? void 0 : P.isLive) ? -1 : e.media.getDuration() ? pe(e.media.getDuration()) : (null == P ? void 0 : P.duration) ? pe(null == P ? void 0 : P.duration) : 0,
                        cbcContextVideo: n(P),
                        playerContextVideo: {
                          liveondemand: P.isLive ? "Live" : "On-Demand",
                          pdkplayername: "wpp-phoenix-player"
                        }
                      };
                    })());
                  },
                  i = e => {
                    switch (e.to) {
                      case E.ENDED:
                        o();
                        break;
                      case E.PLAYING:
                        if (e.from === E.ADVERTISING) break;
                        s();
                        break;
                      case E.PAUSED:
                        c();
                    }
                  },
                  o = () => {
                    N = !0, O = !0, f("chapterComplete", S), f("videoComplete", S), C = !1, M = 0;
                  },
                  s = () => {
                    e.getStatus().from !== E.ADVERTISING && (C || r(), f("videoPlay", S));
                  },
                  c = () => {
                    f("videoPause", S);
                  },
                  u = a => {
                    const n = t(a.currentTime);
                    if (_.debug({
                      caller: l,
                      name: "Analytics",
                      message: `onTimeUpdated payload ${JSON.stringify(a)} currentPlayhead ${x} roundedCurrentTime ${n}`
                    }), n === x) return;
                    x = n;
                    const r = e.getStatus().to;
                    [E.ENDED, E.ERROR, E.PAUSED, E.ADVERTISING_PAUSED].includes(r) || f("updatePlayHead", !S, {
                      playhead: x,
                      closedCaptionEnabled: B
                    });
                  },
                  A = e => {
                    let t;
                    switch (U && (U = !1), M++, e) {
                      case -1:
                        t = "post-roll";
                        break;
                      case 0:
                        t = "pre-roll";
                        break;
                      default:
                        t = "mid-roll-" + e;
                    }
                    f("adBreakStart", S, {
                      name: t,
                      position: M
                    });
                  },
                  m = () => {
                    1 === M && (U = !0), f("adBreakComplete", S);
                  },
                  g = e => {
                    const t = {
                      id: e.id,
                      length: e.duration,
                      position: e.position,
                      name: e.title
                    };
                    f("adStart", !S, t);
                  },
                  p = e => {
                    f("adComplete", !S, {
                      id: e
                    });
                  },
                  T = () => {
                    U || k || (U = !0);
                  },
                  y = () => {
                    C && f("seekStart", S);
                  },
                  D = () => {
                    C && f("seekComplete", S);
                  },
                  h = async e => {
                    const {
                        show: t,
                        ...a
                      } = e,
                      n = a;
                    n.length = pe(n.length), (null == P ? void 0 : P.isLive) && P.callSign && "audio" === P.format && (n.cbcContextChapter = {
                      show: null != t ? t : ""
                    }), await (async () => {
                      if (!(null == P ? void 0 : P.adOrder) && !(null == P ? void 0 : P.adUrl) || k) return;
                      let e = 0;
                      return new Promise(t => {
                        L = setInterval(() => {
                          e++, 3 !== e || M || (clearInterval(L), t()), U && (clearInterval(L), t());
                        }, 1e3);
                      });
                    })(), k || (k = !0), f("chapterStart", !S, n);
                  },
                  I = () => {
                    if (k) return !0 === N ? (N = !1, void (k = !1)) : void f("chapterComplete", S);
                  },
                  R = e => {
                    B = !!e;
                  },
                  f = (a, n, r) => {
                    if (!b || !w) return;
                    const i = {
                      ...r
                    };
                    !0 === n && (i.playhead = t(e.media.getCurrentTime()));
                    try {
                      _.debug({
                        caller: l,
                        name: "Analytics",
                        message: `CBC.APP.SC.VideoHeartbeat.${a}(${w}, ${JSON.stringify(i)})`
                      }), b[a].call(window, w, i);
                    } catch (e) {
                      _.error({
                        caller: l,
                        name: "Analytics",
                        message: `Analytics track error: ${e}`,
                        critical: !1
                      });
                    }
                  },
                  S = !0,
                  _ = d();
                let b,
                  L,
                  P = null,
                  w = null,
                  C = !1,
                  M = 0,
                  N = !1,
                  O = !1,
                  k = !1,
                  U = !1,
                  x = 0,
                  B = !1;
                return {
                  init: e => {
                    if (_.debug({
                      caller: l,
                      name: "Analytics",
                      message: "Init"
                    }), !b) try {
                      b = window.CBC.APP.SC.VideoHeartbeat, w = b.init({
                        playerName: "wpp-phoenix-player",
                        comScore: !0
                      }), N = !1, O = !1;
                    } catch (e) {
                      _.error({
                        caller: l,
                        name: "Analytics",
                        message: `Analytics initialization error: ${e}`,
                        critical: !1
                      });
                    }
                    b && a(!0), P = e;
                  },
                  destroy: () => {
                    _.debug({
                      caller: l,
                      name: "Analytics",
                      message: "destroy"
                    }), !O && w && b.videoUnload(w), a(!1), clearInterval(L), P = null, C = !1, M = 0, N = !1, O = !1, k = !1, x = 0, B = !1;
                  }
                };
              })(a), o = (e => {
                const t = () => {
                    l && clearTimeout(l), l = null;
                  },
                  a = () => {
                    t(), e.media.play();
                  },
                  n = t => {
                    d === t && t !== Te.READY || (d = t, e.trigger(v.UPCOMING_LIVE_UPDATE, t));
                  },
                  r = e => {
                    const {
                      READY: a,
                      LOADING: r,
                      PLAYING: i
                    } = Te;
                    [a, r, i].includes(e.to) && (n(e.to), t());
                  },
                  i = e => {
                    "NO_COMPATIBLE_SOURCES" === e.name ? (() => {
                      var e;
                      t();
                      const r = Date.now(),
                        i = null !== (e = null == s ? void 0 : s.pubDate) && void 0 !== e ? e : r,
                        o = (i - r) / Ee;
                      let d;
                      if (o > 5) {
                        const e = i - r - 3e5;
                        d = e < ye ? e : ye;
                      } else o < 5 && o > 1 ? d = Ee : o <= 1 && o > -15 ? d = 3e4 : o <= -15 && o > -30 ? d = Ee : (d = null, n(Te.TIMEDOUT));
                      null !== d && (l = setTimeout(a, d), n(Te.SCHEDULED));
                    })() : (t(), n(Te.CRITICAL_ERROR));
                  },
                  o = t => {
                    const a = t ? "on" : "off";
                    e[a](v.STATUS_CHANGE, r), e[a](v.CRITICAL_ERROR, i);
                  };
                let s = null,
                  l = null,
                  d = "",
                  c = !1;
                return {
                  init: e => {
                    (null == e ? void 0 : e.isLive) && (s = e, o(!0), n(Te.READY), c = !0);
                  },
                  destroy: () => {
                    c && (s = null, n(Te.READY), o(!1), t(), c = !1);
                  }
                };
              })(a), A = (e => {
                const t = e => {
                    const {
                      duration: t,
                      currentTime: n
                    } = e;
                    t - 5 <= n && (m || (m = !0, a()));
                  },
                  a = async () => {
                    try {
                      const t = n(null == c ? void 0 : c.contentArea),
                        a = await r(),
                        i = await (0, De.W9)(t, a, 14, !0);
                      if (!Array.isArray(i) || 0 === i.length) throw new Error("No recommendations in payload");
                      const o = (t => {
                        const a = e.localStorageManager.getWatchedMediaIds(),
                          n = t.filter(e => !!e.sourceId && !a.includes(e.sourceId));
                        return n.length > 0 ? n : t;
                      })(i);
                      u = o.slice(0, 3), e.trigger(v.RECOMMENDATIONS_AVAILABLE, u);
                    } catch (e) {
                      s.error({
                        caller: l,
                        name: "Recommendations Fetcher",
                        message: `Recommendations fetch error: ${e}`,
                        critical: !1
                      });
                    }
                  },
                  n = e => "News" === e ? "rec4you-short-form-news-video" : "rec4you-short-form-videos",
                  r = async () => {
                    const e = he(),
                      t = await e.getUser();
                    return t ? t.id : "";
                  },
                  i = e => {
                    e.from === E.ENDED && e.to === E.LOADING && m && (m = !1);
                  },
                  o = a => {
                    const n = a ? "on" : "off";
                    e[n](v.PLAYBACK_THROTTLED_TIMEUPDATED, t), e[n](v.STATUS_CHANGE, i);
                  },
                  s = d();
                let c = null,
                  u = null,
                  A = !1,
                  m = !1;
                return {
                  init: e => {
                    (null == e ? void 0 : e.enableRecommendations) && !(null == e ? void 0 : e.isLive) && "video" === (null == e ? void 0 : e.format) && (c = e, o(!0), A = !0);
                  },
                  destroy: () => {
                    A && (c = null, o(!1), u = null, A = !1, m = !1);
                  }
                };
              })(a), m = (t => {
                const a = s(),
                  n = () => {
                    const t = null == c ? void 0 : c.assets[0].key,
                      n = new URLSearchParams(null == t ? void 0 : t.split("?")[1]).get("idMedia");
                    (async t => {
                      var n;
                      const r = a.get("MEDIA_NET_PLAYBACK_LOG_URL") || "https://services.radio-canada.ca/music/dj/v1/playbacklog",
                        s = {
                          "Content-Type": "application/json"
                        };
                      try {
                        const a = {
                            headers: s,
                            method: "POST",
                            body: JSON.stringify(t)
                          },
                          d = await i(r, a);
                        if (d.status === e.ERROR) {
                          const e = null !== (n = d.response.message) && void 0 !== n ? n : "Unknown Error";
                          throw new Error(`Post Error: ${e}`);
                        }
                        o.debug({
                          caller: l,
                          name: "MediaNet Playback Log",
                          message: `log success: WebRadioId ${A}, UserId: ${null == m ? void 0 : m.mediaNetUserId}`
                        });
                      } catch (e) {
                        return o.error({
                          caller: l,
                          name: "MediaNet Playback Log",
                          message: `MediaNet Playback Log Error: ${e.message}`,
                          critical: !1
                        }), null;
                      }
                    })({
                      userId: null == m ? void 0 : m.mediaNetUserId,
                      trackId: parseInt(n),
                      sourceId: 2,
                      webRadioId: A
                    });
                  },
                  r = e => {
                    t[e ? "on" : "off"](v.PLAYBACK_INITIALPLAY, n);
                  },
                  o = d();
                let c = null,
                  u = null,
                  A = null,
                  m = null;
                return {
                  init: (e, t) => {
                    var a, n, i, s, d, g;
                    m = t, c = e, u = (null === (n = null === (a = null == c ? void 0 : c.assets) || void 0 === a ? void 0 : a[0]) || void 0 === n ? void 0 : n.type) || null, A = null !== (g = null === (d = null === (s = null === (i = null == c ? void 0 : c.assets) || void 0 === i ? void 0 : i[0]) || void 0 === s ? void 0 : s.options) || void 0 === d ? void 0 : d.mediaNetWebRadioId) && void 0 !== g ? g : null, o.debug({
                      caller: l,
                      name: "MediaNet Playback Log",
                      message: `init: WebRadioId ${A}, UserId: ${null == t ? void 0 : t.mediaNetUserId}`
                    }), ((null == m ? void 0 : m.mediaNetUserId) && "medianet" === u && A || (o.error({
                      caller: l,
                      name: "MediaNet Playback Log",
                      message: `failed validation: assetType ${u}, WebRadioId ${A}, UserId: ${null == m ? void 0 : m.mediaNetUserId}`,
                      critical: !1
                    }), 0)) && r(!0);
                  },
                  destroy: () => {
                    c = null, u = null, A = null, m = null, r(!1);
                  }
                };
              })(a), g.set("ChapterManager", n), g.set("Analytics", r), g.set("UpcomingLiveManager", o), g.set("RecommendationsFetcher", A), g.set("MediaNetPlaybackLog", m)), null == n || n.destroy(), null == n || n.init(c), null == r || r.destroy(), null == r || r.init(c), null == o || o.destroy(), null == o || o.init(c), null == A || A.destroy(), null == A || A.init(c), null == m || m.destroy(), null == m || m.init(c, t), u = !0, a.localStorageManager.setCurrentMedia(c);
            },
            o = () => {
              const e = Array.from(g.values());
              e && e.forEach(e => {
                null == e || e.destroy();
              }), g.clear();
            };
          let c = null != a ? a : null,
            u = !1;
          const A = Ae(a);
          await (async e => {
            const t = (t, n) => {
                e.isAutoplayAllowed = t, e.autoplayRequiresMuted = n, t || (e.autoPlay = !1, a.debug({
                  caller: "Utils",
                  name: "Autoplay Support",
                  message: "config.autoPlay was set to false"
                }));
              },
              a = d(),
              n = !!(null !== (r = e.muted) && void 0 !== r ? r : (() => {
                let e = null;
                const t = null === localStorage || void 0 === localStorage ? void 0 : localStorage.getItem("wpp-phoenix-core");
                if (t) try {
                  e = JSON.parse(t).muted;
                } catch (e) {
                  a.debug({
                    caller: "Utils",
                    name: "Autoplay Support",
                    message: `error with parsing localStorage JSON: ${e}`
                  });
                }
                return e;
              })());
            var r;
            const i = document.createElement("video");
            i.autoplay = !0, i.playsInline = !0, n && (i.volume = 0, i.muted = !0), i.src = "data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAAJ21kYXQBQCKAo3hQhS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0vAAAC8G1vb3YAAABsbXZoZAAAAAAAAAAAAAAAAAAAA+gAAAALAAEAAAEAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAIadHJhawAAAFx0a2hkAAAAAwAAAAAAAAAAAAAAAQAAAAAAAAALAAAAAAAAAAAAAAABAQAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAJGVkdHMAAAAcZWxzdAAAAAAAAAAB////9QAACAAAAQAAAAABkm1kaWEAAAAgbWRoZAAAAAAAAAAAAAAAAAABdwAAAAQAVcQAAAAAAC1oZGxyAAAAAAAAAABzb3VuAAAAAAAAAAAAAAAAU291bmRIYW5kbGVyAAAAAT1taW5mAAAAEHNtaGQAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAQFzdGJsAAAAZ3N0c2QAAAAAAAAAAQAAAFdtcDRhAAAAAAAAAAEAAAAAAAAAAAACABAAAAAAAAAAAAAAADNlc2RzAAAAAAOAgIAiAAEABICAgBRAFQAAAAAAWtIAAFrSBYCAgAIQCAaAgIABAgAAABhzdHRzAAAAAAAAAAEAAAABAAAEAAAAABxzdHNjAAAAAAAAAAEAAAABAAAAAQAAAAEAAAAUc3RzegAAAAAAAAAfAAAAAQAAABRzdGNvAAAAAAAAAAEAAAAsAAAAGnNncGQBAAAAcm9sbAAAAAIAAAAB//8AAAAcc2JncAAAAAByb2xsAAAAAQAAAAEAAAABAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ny44My4xMDA=";
            try {
              await Promise.race([i.play(), new Promise((e, t) => setTimeout(t, 1500))]), t(!0, n), a.debug({
                caller: "Utils",
                name: "Autoplay Support",
                message: "Autoplay is supported"
              });
            } catch (e) {
              t(!1, !0), a.debug({
                caller: "Utils",
                name: "Autoplay Support",
                message: "Autoplay is not supported"
              });
            }
          })(t);
          const m = ue(t, A),
            g = new Map(),
            [p, T] = (e => {
              const t = e;
              return [t, {
                ...e,
                trigger: void 0,
                media: n(t)
              }];
            })(m);
          return r(p), {
            ...T,
            destroy: () => {
              const e = p.destroy;
              return u = !1, c = null, o(), e();
            }
          };
        },
        Re = e => {
          const t = new Map();
          return {
            createPlayer: async (a, n) => {
              const r = s();
              await r.seed(null == e ? void 0 : e.env), d(a.debug).debug({
                name: "Phoenix",
                message: "Create Player"
              });
              const i = await Ie(a, n);
              return t.set(i.uid, i), i;
            },
            getPlayers: e => e && t.get(e) || Array.from(t.values()),
            destroyPlayer: e => {
              var a;
              null === (a = t.get(e)) || void 0 === a || a.destroy(), t.delete(e);
            }
          };
        };
    })(), n.default;
  })());
})(module);
const PhoenixCBCCore = /*@__PURE__*/getDefaultExportFromCjs(module.exports);
var STATUS;
(function (STATUS) {
  STATUS["READY"] = "READY";
  STATUS["LOADING"] = "LOADING";
  STATUS["ERROR"] = "ERROR";
  STATUS["PLAYING"] = "PLAYING";
  STATUS["ADVERTISING"] = "ADVERTISING";
  STATUS["ADVERTISING_PAUSED"] = "ADVERTISING_PAUSED";
  STATUS["PAUSED"] = "PAUSED";
  STATUS["ENDED"] = "ENDED";
})(STATUS || (STATUS = {}));
var EVENTS;
(function (EVENTS) {
  EVENTS["CRITICAL_ERROR"] = "CRITICAL_ERROR";
  EVENTS["BUFFER_UPDATED"] = "BUFFER_UPDATED";
  EVENTS["LIVE_SYNC_POSITION_CHANGE"] = "LIVE_SYNC_POSITION_CHANGE";
  EVENTS["FULL_SCREEN_CHANGE"] = "FULL_SCREEN_CHANGE";
  EVENTS["MEDIA_ASPECT_RATIO_AVAILABLE"] = "MEDIA_ASPECT_RATIO_AVAILABLE";
  EVENTS["STATUS_CHANGE"] = "STATUS_CHANGE";
  EVENTS["ASSET_LOADED"] = "ASSET_LOADED";
  EVENTS["PLAYBACK_INITIALPLAY"] = "PLAYBACK_INITIALPLAY";
  EVENTS["PLAYBACK_TIMEUPDATED"] = "PLAYBACK_TIMEUPDATED";
  EVENTS["PLAYBACK_THROTTLED_TIMEUPDATED"] = "PLAYBACK_THROTTLED_TIMEUPDATED";
  EVENTS["PLAYBACK_SEEKING"] = "PLAYBACK_SEEKING";
  EVENTS["PLAYBACK_SEEKED"] = "PLAYBACK_SEEKED";
  EVENTS["PLAYBACK_VOLUMECHANGE"] = "PLAYBACK_VOLUMECHANGE";
  EVENTS["PLAYBACK_MUTEDCHANGE"] = "PLAYBACK_MUTEDCHANGE";
  EVENTS["AD_ERRORED"] = "AD_ERRORED";
  EVENTS["AD_LOADED"] = "AD_LOADED";
  EVENTS["AD_STARTED"] = "AD_STARTED";
  EVENTS["AD_COMPLETED"] = "AD_COMPLETED";
  EVENTS["AD_BREAK_STARTED"] = "AD_BREAK_STARTED";
  EVENTS["AD_BREAK_COMPLETED"] = "AD_BREAK_COMPLETED";
  EVENTS["AD_REMAINING_TIME_UPDATED"] = "AD_REMAINING_TIME_UPDATED";
  EVENTS["AD_FIRST_QUARTILE"] = "AD_FIRST_QUARTILE";
  EVENTS["AD_MIDPOINT"] = "AD_MIDPOINT";
  EVENTS["AD_THIRD_QUARTILE"] = "AD_THIRD_QUARTILE";
  EVENTS["AD_SKIPPED"] = "AD_SKIPPED";
  EVENTS["TEXTTRACK_AVAILABILITY_CHANGE"] = "TEXTTRACK_AVAILABILITY_CHANGE";
  EVENTS["AUDIOTRACK_AVAILABILITY_CHANGE"] = "AUDIOTRACK_AVAILABILITY_CHANGE";
  EVENTS["HLSJS_PARSE_FRAG_METADATA"] = "HLSJS_PARSE_FRAG_METADATA";
  EVENTS["CHAPTER_START"] = "CHAPTER_START";
  EVENTS["CHAPTER_COMPLETE"] = "CHAPTER_COMPLETE";
  EVENTS["UPCOMING_LIVE_UPDATE"] = "UPCOMING_LIVE_UPDATE";
  EVENTS["RECOMMENDATIONS_AVAILABLE"] = "RECOMMENDATIONS_AVAILABLE";
})(EVENTS || (EVENTS = {}));
var INDICATORS;
(function (INDICATORS) {
  INDICATORS["PLAY"] = "play";
  INDICATORS["PAUSE"] = "pause";
  INDICATORS["STOP"] = "stop";
  INDICATORS["VOLUME_UP"] = "volume-up";
  INDICATORS["VOLUME_DOWN"] = "volume-down";
  INDICATORS["SKIP_FORWARD"] = "skip-forward";
  INDICATORS["SKIP_BACKWARD"] = "skip-backward";
  INDICATORS["HIDDEN"] = "hidden";
  INDICATORS["MUTE"] = "mute";
})(INDICATORS || (INDICATORS = {}));
const IMA_AD_TYPE = {
  CLIENTSIDE: "CLIENTSIDE",
  DYNAMIC: "DYNAMIC"
};
const KEYBOARD_KEY_CODES = {
  SPACE: "Space",
  ARROWUP: "ArrowUp",
  ARROWDOWN: "ArrowDown",
  ARROWRIGHT: "ArrowRight",
  ARROWLEFT: "ArrowLeft",
  ENTER: "Enter",
  ESCAPE: "Escape",
  TAB: "Tab",
  KEYM: "KeyM",
  KEYF: "KeyF",
  KEYC: "KeyC"
};
const VOLUME_INCREMENT = 0.1;
const SKIP_INCREMENT = 5;
const HIDE_CONTROLS_TIMEOUT_DURATION = 5000;
const LIVE_UPCOMING_STATUS = Object.assign(Object.assign({}, STATUS), {
  SCHEDULED: "SCHEDULED",
  TIMEDOUT: "TIMEDOUT",
  CRITICAL_ERROR: "CRITICAL_ERROR"
});
const PLAYER_VERSION = "2.24.1";
const EMPTY_MEDIA_DATA = {
  assets: null,
  format: null
};
const ONE_SECOND_IN_MS = 1000;
const ONE_MINUTE_IN_MS = 60000;
const FIVE_MINUTES_IN_MS = 300000;
const ONE_DAY_IN_MS = 86400000;
const LIVE_OFFSET = 40;
const locale = Locale();
const getFormattedTime = duration => {
  if (duration === undefined) return;
  let result = duration >= 0 ? "" : "-";
  const parsedDuration = Math.floor(Math.abs(parseFloat(duration)));
  const hours = Math.floor(parsedDuration / 3600);
  const minutes = Math.floor(parsedDuration / 60 % 60);
  const seconds = Math.round(parsedDuration % 60);
  if (hours) {
    result += hours + ":";
    result += (minutes < 10 ? "0" + minutes : minutes) + ":";
  } else {
    result += minutes + ":";
  }
  result += seconds < 10 ? "0" + seconds : seconds;
  return result;
};
const getFormattedTimeOfDay = function (timestamp) {
  let includeSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  let displayHours;
  if (hours === 0) {
    displayHours = 12;
  } else if (hours > 0 && hours <= 12) {
    displayHours = hours;
  } else {
    displayHours = hours - 12;
  }
  const amPM = hours >= 12 ? "pm" : "am";
  let minutesString = minutes.toString();
  if (minutes < 10) minutesString = "0" + minutes;
  let secondsString = seconds.toString();
  if (seconds < 10) secondsString = "0" + seconds;
  const suffix = includeSeconds ? ":" + secondsString : amPM;
  return displayHours + ":" + minutesString + suffix;
};
const getFormattedDate = timestamp => {
  const readableDate = new Date(timestamp);
  const readableMonth = readableDate.toLocaleString(locale.getLanguage(), {
    month: "short"
  });
  return readableMonth + " " + readableDate.getDate() + ", " + readableDate.getFullYear();
};
const getTimeSince = (timestamp, includeSeconds, isLive) => {
  const today = Date.now();
  if (typeof timestamp === "string") timestamp = parseInt(timestamp);
  if (Number.isNaN(timestamp) || !Number.isFinite(timestamp)) {
    timestamp = today;
  }
  const str = (time, unit) => {
    return locale.getLanguage() === "fr" ? `${locale.ago} ${time} ${unit}` : `${time} ${unit} ${locale.ago}`;
  };
  const pastTemplate = (time, unit) => {
    return isLive ? `${locale.started} ${str(time, unit)}` : str(time, unit);
  };
  const futureTemplate = (time, unit) => {
    return isLive ? `${locale.in} ${time} ${unit}` : `${time} ${unit}`;
  };
  const nowTemplate = locale.now;
  const isInFuture = today < timestamp;
  const timeDiff = Math.abs(today - timestamp) / 1000;
  const timeUnits = [
  // this array is sorted by size!
  {
    label: locale.year,
    size: 31536000
  }, {
    label: locale.month,
    size: 2592000
  }, {
    label: locale.day,
    size: 86400
  }, {
    label: locale.hour,
    size: 3600
  }, {
    label: locale.minute,
    size: 60
  }];
  if (includeSeconds) {
    timeUnits.push({
      label: locale.second,
      size: 1
    });
  }
  let selectedTimeUnit;
  function selectNextTimeUnit() {
    selectedTimeUnit = timeUnits[timeUnits.indexOf(selectedTimeUnit) + 1];
  }
  function timeIsTooBroad() {
    return timeDiff < selectedTimeUnit.size;
  }
  do {
    selectNextTimeUnit();
    if (selectedTimeUnit === undefined) return nowTemplate;
  } while (timeIsTooBroad());
  const numTimeUnits = Math.round(timeDiff / selectedTimeUnit.size);
  const label = selectedTimeUnit.label + (numTimeUnits > 1 ? "s" : "");
  return isInFuture ? futureTemplate(numTimeUnits, label) : pastTemplate(numTimeUnits, label);
};
const getRoundedOffsetFromSeekableEnd = (currentTime, seekableEnd) => {
  return Math.round((currentTime - seekableEnd) / 10) * 10;
};
const isAtLiveEdge = (currentTime, seekableEnd) => {
  return Math.abs(currentTime - seekableEnd) <= LIVE_OFFSET;
};
export { EVENTS as E, FIVE_MINUTES_IN_MS as F, HIDE_CONTROLS_TIMEOUT_DURATION as H, INDICATORS as I, KEYBOARD_KEY_CODES as K, LIVE_UPCOMING_STATUS as L, ONE_MINUTE_IN_MS as O, PLAYER_VERSION as P, STATUS as S, VOLUME_INCREMENT as V, SKIP_INCREMENT as a, PhoenixCBCCore as b, EMPTY_MEDIA_DATA as c, IMA_AD_TYPE as d, getTimeSince as e, ONE_DAY_IN_MS as f, getFormattedTime as g, ONE_SECOND_IN_MS as h, isAtLiveEdge as i, getFormattedDate as j, getFormattedTimeOfDay as k, getRoundedOffsetFromSeekableEnd as l };